/*!
 * Web analytics for Snowplow v3.13.1 (http://bit.ly/sp-js)
 * Copyright 2022 Snowplow Analytics Ltd, 2010 Anthon Pang
 * Licensed under BSD-3-Clause
 */

'use strict';
!(function () {
  function e(e, n) {
    var t,
      o = {};
    for (t in e)
      Object.prototype.hasOwnProperty.call(e, t) &&
        0 > n.indexOf(t) &&
        (o[t] = e[t]);
    if (null != e && 'function' == typeof Object.getOwnPropertySymbols) {
      var r = 0;
      for (t = Object.getOwnPropertySymbols(e); r < t.length; r++)
        0 > n.indexOf(t[r]) &&
          Object.prototype.propertyIsEnumerable.call(e, t[r]) &&
          (o[t[r]] = e[t[r]]);
    }
    return o;
  }
  function n(e, n, t) {
    if (t || 2 === arguments.length)
      for (var o, r = 0, i = n.length; r < i; r++)
        (!o && r in n) ||
          (o || (o = Array.prototype.slice.call(n, 0, r)), (o[r] = n[r]));
    return e.concat(o || Array.prototype.slice.call(n));
  }
  function t() {
    var e,
      n = {},
      t = [],
      o = [],
      i = [],
      a = function (e, t) {
        null != t && '' !== t && (n[e] = t);
      };
    return {
      add: a,
      addDict: function (e) {
        for (var n in e)
          Object.prototype.hasOwnProperty.call(e, n) && a(n, e[n]);
      },
      addJson: function (e, n, i) {
        i &&
          r(i) &&
          ((e = { keyIfEncoded: e, keyIfNotEncoded: n, json: i }),
          o.push(e),
          t.push(e));
      },
      addContextEntity: function (e) {
        i.push(e);
      },
      getPayload: function () {
        return n;
      },
      getJson: function () {
        return t;
      },
      withJsonProcessor: function (n) {
        e = n;
      },
      build: function () {
        return null == e || e(this, o, i), n;
      },
    };
  }
  function o(e) {
    return function (t, o, r) {
      for (
        var i = function (n, o, r) {
            if (((n = JSON.stringify(n)), e)) {
              if (((r = t.add), n)) {
                var i = 0,
                  a = 0,
                  c = [];
                if (n) {
                  n = unescape(encodeURIComponent(n));
                  do {
                    var s = n.charCodeAt(i++),
                      u = n.charCodeAt(i++),
                      l = n.charCodeAt(i++),
                      d = (s << 16) | (u << 8) | l;
                    (s = (d >> 18) & 63),
                      (u = (d >> 12) & 63),
                      (l = (d >> 6) & 63),
                      (d &= 63),
                      (c[a++] =
                        Ke.charAt(s) +
                        Ke.charAt(u) +
                        Ke.charAt(l) +
                        Ke.charAt(d));
                  } while (i < n.length);
                  (i = c.join('')),
                    (n =
                      ((n = n.length % 3) ? i.slice(0, n - 3) : i) +
                      '==='.slice(n || 3));
                }
                n = n.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
              }
              r.call(t, o, n);
            } else t.add(r, n);
          },
          a = function (n, o) {
            if (!n) {
              var r = t.getPayload();
              if (e ? r.cx : r.co) {
                var i = (n = JSON).parse;
                if (e) {
                  if ((r = r.cx)) {
                    switch (4 - (r.length % 4)) {
                      case 2:
                        r += '==';
                        break;
                      case 3:
                        r += '=';
                    }
                    r = (function (e) {
                      var n,
                        t = 0,
                        o = 0,
                        r = '',
                        i = [];
                      if (!e) return e;
                      e += '';
                      do {
                        var a = Ke.indexOf(e.charAt(t++)),
                          c = Ke.indexOf(e.charAt(t++));
                        r = Ke.indexOf(e.charAt(t++));
                        var s = Ke.indexOf(e.charAt(t++)),
                          u = (a << 18) | (c << 12) | (r << 6) | s;
                        (a = (u >> 16) & 255),
                          (c = (u >> 8) & 255),
                          (u &= 255),
                          (i[o++] =
                            64 === r
                              ? String.fromCharCode(a)
                              : 64 === s
                              ? String.fromCharCode(a, c)
                              : String.fromCharCode(a, c, u));
                      } while (t < e.length);
                      return (
                        (r = i.join('')),
                        (n = r.replace(/\0+$/, '')),
                        decodeURIComponent(
                          n
                            .split('')
                            .map(function (e) {
                              return (
                                '%' +
                                ('00' + e.charCodeAt(0).toString(16)).slice(-2)
                              );
                            })
                            .join('')
                        )
                      );
                    })((r = r.replace(/-/g, '+').replace(/_/g, '/')));
                  }
                } else r = r.co;
                n = i.call(n, r);
              } else n = void 0;
            }
            return n ? (n.data = n.data.concat(o.data)) : (n = o), n;
          },
          c = void 0,
          s = 0;
        s < o.length;
        s++
      ) {
        var u = o[s];
        'cx' === u.keyIfEncoded
          ? (c = a(c, u.json))
          : i(u.json, u.keyIfEncoded, u.keyIfNotEncoded);
      }
      (o.length = 0),
        r.length &&
          ((c = a(
            c,
            (o = {
              schema:
                'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
              data: n([], r, !0),
            })
          )),
          (r.length = 0)),
        c && i(c, 'cx', 'co');
    };
  }
  function r(e) {
    if (!i(e)) return !1;
    for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) return !0;
    return !1;
  }
  function i(e) {
    return (
      null != e &&
      (e.constructor === {}.constructor || e.constructor === [].constructor)
    );
  }
  function a() {
    var e = [],
      n = [];
    return {
      getGlobalPrimitives: function () {
        return e;
      },
      getConditionalProviders: function () {
        return n;
      },
      addGlobalContexts: function (t) {
        for (var o = [], r = [], i = 0; i < t.length; i++) {
          var a = t[i];
          y(a) ? o.push(a) : g(a) && r.push(a);
        }
        (e = e.concat(r)), (n = n.concat(o));
      },
      clearGlobalContexts: function () {
        (n = []), (e = []);
      },
      removeGlobalContexts: function (t) {
        for (
          var o = function (t) {
              y(t)
                ? (n = n.filter(function (e) {
                    return JSON.stringify(e) !== JSON.stringify(t);
                  }))
                : g(t) &&
                  (e = e.filter(function (e) {
                    return JSON.stringify(e) !== JSON.stringify(t);
                  }));
            },
            r = 0;
          r < t.length;
          r++
        )
          o(t[r]);
      },
      getApplicableContexts: function (t) {
        e: {
          for (var o = 0, r = t.getJson(); o < r.length; o++) {
            var i = r[o];
            if (
              'ue_px' === i.keyIfEncoded &&
              'object' == typeof i.json.data &&
              'string' == typeof (i = i.json.data.schema)
            ) {
              o = i;
              break e;
            }
          }
          o = '';
        }
        (i = 'string' == typeof (r = t.getPayload().e) ? r : ''), (r = []);
        var a = A(e, t, i, o);
        return (
          r.push.apply(r, a),
          (t = (function (e, n, t, o) {
            var r;
            return (
              (e = b(e).map(function (e) {
                e: {
                  if (v(e)) {
                    var r = e[0],
                      i = !1;
                    try {
                      i = r({
                        event: n.getPayload(),
                        eventType: t,
                        eventSchema: o,
                      });
                    } catch (e) {
                      i = !1;
                    }
                    if (!0 === i) {
                      e = A(e[1], n, t, o);
                      break e;
                    }
                  } else if (
                    h(e) &&
                    (function (e, n) {
                      var t = 0,
                        o = 0,
                        r = e.accept;
                      return (
                        Array.isArray(r)
                          ? e.accept.some(function (e) {
                              return w(e, n);
                            }) && o++
                          : 'string' == typeof r && w(r, n) && o++,
                        (r = e.reject),
                        Array.isArray(r)
                          ? e.reject.some(function (e) {
                              return w(e, n);
                            }) && t++
                          : 'string' == typeof r && w(r, n) && t++,
                        0 < o && 0 === t
                      );
                    })(e[0], o)
                  ) {
                    e = A(e[1], n, t, o);
                    break e;
                  }
                  e = [];
                }
                if (e && 0 !== e.length) return e;
              })),
              (r = []).concat.apply(
                r,
                e.filter(function (e) {
                  return null != e && e.filter(Boolean);
                })
              )
            );
          })(n, t, i, o)),
          r.push.apply(r, t),
          r
        );
      },
    };
  }
  function c(e) {
    for (var n, t = [], o = 1; o < arguments.length; o++)
      t[o - 1] = arguments[o];
    return null !==
      (n =
        null == e
          ? void 0
          : e
              .map(function (e) {
                if ('function' != typeof e) return e;
                try {
                  return e.apply(void 0, t);
                } catch (e) {}
              })
              .filter(Boolean)) && void 0 !== n
      ? n
      : [];
  }
  function s(e) {
    return (
      !!((e = e.split('.')) && 1 < e.length) &&
      (function (e) {
        if ('*' === e[0] || '*' === e[1]) return !1;
        if (0 < e.slice(2).length) {
          var n = !1,
            t = 0;
          for (e = e.slice(2); t < e.length; t++)
            if ('*' === e[t]) n = !0;
            else if (n) return !1;
          return !0;
        }
        return 2 == e.length;
      })(e)
    );
  }
  function u(e) {
    if (
      null !==
        (e =
          /^iglu:((?:(?:[a-zA-Z0-9-_]+|\*).)+(?:[a-zA-Z0-9-_]+|\*))\/([a-zA-Z0-9-_.]+|\*)\/jsonschema\/([1-9][0-9]*|\*)-(0|[1-9][0-9]*|\*)-(0|[1-9][0-9]*|\*)$/.exec(
            e
          )) &&
      s(e[1])
    )
      return e.slice(1, 6);
  }
  function l(e) {
    if ((e = u(e))) {
      var n = e[0];
      return 5 === e.length && s(n);
    }
    return !1;
  }
  function d(e) {
    return (
      Array.isArray(e) &&
      e.every(function (e) {
        return 'string' == typeof e;
      })
    );
  }
  function f(e) {
    return d(e)
      ? e.every(function (e) {
          return l(e);
        })
      : 'string' == typeof e && l(e);
  }
  function m(e) {
    return (
      !!(r(e) && 'schema' in e && 'data' in e) &&
      'string' == typeof e.schema &&
      'object' == typeof e.data
    );
  }
  function p(e) {
    return 'function' == typeof e && 1 >= e.length;
  }
  function g(e) {
    return p(e) || m(e);
  }
  function v(e) {
    return (
      !(!Array.isArray(e) || 2 !== e.length) &&
      (Array.isArray(e[1]) ? p(e[0]) && e[1].every(g) : p(e[0]) && g(e[1]))
    );
  }
  function h(e) {
    return (
      !(!Array.isArray(e) || 2 !== e.length) &&
      !!(function (e) {
        var n = 0;
        if (null != e && 'object' == typeof e && !Array.isArray(e)) {
          if (Object.prototype.hasOwnProperty.call(e, 'accept')) {
            if (!f(e.accept)) return !1;
            n += 1;
          }
          if (Object.prototype.hasOwnProperty.call(e, 'reject')) {
            if (!f(e.reject)) return !1;
            n += 1;
          }
          return 0 < n && 2 >= n;
        }
        return !1;
      })(e[0]) &&
      (Array.isArray(e[1]) ? e[1].every(g) : g(e[1]))
    );
  }
  function y(e) {
    return v(e) || h(e);
  }
  function w(e, n) {
    if (!l(e)) return !1;
    if (
      ((e = u(e)),
      (n =
        null !==
        (n =
          /^iglu:([a-zA-Z0-9-_.]+)\/([a-zA-Z0-9-_]+)\/jsonschema\/([1-9][0-9]*)-(0|[1-9][0-9]*)-(0|[1-9][0-9]*)$/.exec(
            n
          ))
          ? n.slice(1, 6)
          : void 0),
      e && n)
    ) {
      if (
        !(function (e, n) {
          if (((n = n.split('.')), (e = e.split('.')), n && e)) {
            if (n.length !== e.length) return !1;
            for (var t = 0; t < e.length; t++) if (!k(n[t], e[t])) return !1;
            return !0;
          }
          return !1;
        })(e[0], n[0])
      )
        return !1;
      for (var t = 1; 5 > t; t++) if (!k(e[t], n[t])) return !1;
      return !0;
    }
    return !1;
  }
  function k(e, n) {
    return (e && n && '*' === e) || e === n;
  }
  function b(e) {
    return Array.isArray(e) ? e : [e];
  }
  function A(e, n, t, o) {
    var r;
    return (
      (e = b(e).map(function (e) {
        e: if (m(e)) e = [e];
        else {
          if (p(e)) {
            n: {
              var r = void 0;
              try {
                if (
                  ((r = e({
                    event: n.getPayload(),
                    eventType: t,
                    eventSchema: o,
                  })),
                  (Array.isArray(r) && r.every(m)) || m(r))
                ) {
                  var i = r;
                  break n;
                }
                i = void 0;
                break n;
              } catch (e) {}
              i = void 0;
            }
            if (m(i)) {
              e = [i];
              break e;
            }
            if (Array.isArray(i)) {
              e = i;
              break e;
            }
          }
          e = void 0;
        }
        if (e && 0 !== e.length) return e;
      })),
      (r = []).concat.apply(
        r,
        e.filter(function (e) {
          return null != e && e.filter(Boolean);
        })
      )
    );
  }
  function _(e) {
    void 0 === e && (e = {});
    var t,
      r,
      c,
      s,
      u,
      l,
      d,
      f = e.base64,
      m = e.corePlugins,
      p = null != m ? m : [];
    (t = null == f || f),
      (r = p),
      (c = e.callback),
      (s = (function (e) {
        return {
          addPluginContexts: function (t) {
            var o = t ? n([], t, !0) : [];
            return (
              e.forEach(function (e) {
                try {
                  e.contexts && o.push.apply(o, e.contexts());
                } catch (e) {
                  We.error('Error adding plugin contexts', e);
                }
              }),
              o
            );
          },
        };
      })(r)),
      (u = a()),
      (l = t),
      (d = {});
    var g = Ee(
      Ee(
        {},
        (e = {
          track: function (e, n, t) {
            e.withJsonProcessor(o(l)),
              e.add('eid', Ye.v4()),
              e.addDict(d),
              (t = (function (e) {
                return null == e
                  ? { type: 'dtm', value: new Date().getTime() }
                  : 'number' == typeof e
                  ? { type: 'dtm', value: e }
                  : 'ttm' === e.type
                  ? { type: 'ttm', value: e.value }
                  : { type: 'dtm', value: e.value || new Date().getTime() };
              })(t)),
              e.add(t.type, t.value.toString()),
              (n = (function (e, n) {
                e = u.getApplicableContexts(e);
                var t = [];
                return (
                  n && n.length && t.push.apply(t, n),
                  e && e.length && t.push.apply(t, e),
                  t
                );
              })(e, s.addPluginContexts(n))),
              void 0 !==
                (n =
                  n && n.length
                    ? {
                        schema:
                          'iglu:com.snowplowanalytics.snowplow/contexts/jsonschema/1-0-0',
                        data: n,
                      }
                    : void 0) && e.addJson('cx', 'co', n),
              r.forEach(function (n) {
                try {
                  n.beforeTrack && n.beforeTrack(e);
                } catch (e) {
                  We.error('Plugin beforeTrack', e);
                }
              }),
              'function' == typeof c && c(e);
            var i = e.build();
            return (
              r.forEach(function (e) {
                try {
                  e.afterTrack && e.afterTrack(i);
                } catch (e) {
                  We.error('Plugin afterTrack', e);
                }
              }),
              i
            );
          },
          addPayloadPair: function (e, n) {
            d[e] = n;
          },
          getBase64Encoding: function () {
            return l;
          },
          setBase64Encoding: function (e) {
            l = e;
          },
          addPayloadDict: function (e) {
            for (var n in e)
              Object.prototype.hasOwnProperty.call(e, n) && (d[n] = e[n]);
          },
          resetPayloadPairs: function (e) {
            d = i(e) ? e : {};
          },
          setTrackerVersion: function (e) {
            d.tv = e;
          },
          setTrackerNamespace: function (e) {
            d.tna = e;
          },
          setAppId: function (e) {
            d.aid = e;
          },
          setPlatform: function (e) {
            d.p = e;
          },
          setUserId: function (e) {
            d.uid = e;
          },
          setScreenResolution: function (e, n) {
            d.res = e + 'x' + n;
          },
          setViewport: function (e, n) {
            d.vp = e + 'x' + n;
          },
          setColorDepth: function (e) {
            d.cd = e;
          },
          setTimezone: function (e) {
            d.tz = e;
          },
          setLang: function (e) {
            d.lang = e;
          },
          setIpAddress: function (e) {
            d.ip = e;
          },
          setUseragent: function (e) {
            d.ua = e;
          },
          addGlobalContexts: function (e) {
            u.addGlobalContexts(e);
          },
          clearGlobalContexts: function () {
            u.clearGlobalContexts();
          },
          removeGlobalContexts: function (e) {
            u.removeGlobalContexts(e);
          },
        })
      ),
      {
        addPlugin: function (e) {
          var n, t;
          (e = e.plugin),
            p.push(e),
            null === (n = e.logger) || void 0 === n || n.call(e, We),
            null === (t = e.activateCorePlugin) || void 0 === t || t.call(e, g);
        },
      }
    );
    return (
      null == p ||
        p.forEach(function (e) {
          var n, t;
          null === (n = e.logger) || void 0 === n || n.call(e, We),
            null === (t = e.activateCorePlugin) || void 0 === t || t.call(e, g);
        }),
      g
    );
  }
  function P(e) {
    var n = e.event;
    return (
      (e = {
        schema:
          'iglu:com.snowplowanalytics.snowplow/unstruct_event/jsonschema/1-0-0',
        data: { schema: (e = n.schema), data: n.data },
      }),
      (n = t()).add('e', 'ue'),
      n.addJson('ue_px', 'ue_pr', e),
      n
    );
  }
  function T(e) {
    return P({
      event: (e = {
        schema:
          'iglu:com.snowplowanalytics.snowplow/link_click/jsonschema/1-0-1',
        data: C({
          targetUrl: e.targetUrl,
          elementId: e.elementId,
          elementClasses: e.elementClasses,
          elementTarget: e.elementTarget,
          elementContent: e.elementContent,
        }),
      }),
    });
  }
  function C(e, n) {
    void 0 === n && (n = {});
    var t,
      o = {};
    for (t in e) (n[t] || (null !== e[t] && void 0 !== e[t])) && (o[t] = e[t]);
    return o;
  }
  function S(e, n, t) {
    void 0 === t && (t = 63072e3);
    try {
      var o = window.localStorage,
        r = Date.now() + 1e3 * t;
      return (
        o.setItem(''.concat(e, '.expires'), r.toString()), o.setItem(e, n), !0
      );
    } catch (e) {
      return !1;
    }
  }
  function O(e) {
    try {
      var n = window.localStorage;
      return n.removeItem(e), n.removeItem(e + '.expires'), !0;
    } catch (e) {
      return !1;
    }
  }
  function x(e) {
    try {
      return window.sessionStorage.getItem(e);
    } catch (e) {}
  }
  function E(e) {
    return (
      (Number.isInteger && Number.isInteger(e)) ||
      ('number' == typeof e && isFinite(e) && Math.floor(e) === e)
    );
  }
  function I(e) {
    return !(!e || 'function' != typeof e);
  }
  function j(e) {
    if (!e || 'string' != typeof e.valueOf()) {
      e = e.text || '';
      var n = document.getElementsByTagName('title');
      n && null != n[0] && (e = n[0].text);
    }
    return e;
  }
  function N(e) {
    var n = /^(?:(?:https?|ftp):)\/*(?:[^@]+@)?([^:/#]+)/.exec(e);
    return n ? n[1] : e;
  }
  function L(e) {
    var n = e.length;
    return (
      '.' === e.charAt(--n) && (e = e.slice(0, n)),
      '*.' === e.slice(0, 2) && (e = e.slice(1)),
      e
    );
  }
  function D(e) {
    var n = window,
      t = z('referrer', n.location.href) || z('referer', n.location.href);
    if (t) return t;
    if (e) return e;
    try {
      if (n.top) return n.top.document.referrer;
      if (n.parent) return n.parent.document.referrer;
    } catch (e) {}
    return document.referrer;
  }
  function B(e, n, t, o) {
    return e.addEventListener
      ? (e.addEventListener(n, t, o), !0)
      : e.attachEvent
      ? e.attachEvent('on' + n, t)
      : void (e['on' + n] = t);
  }
  function z(e, n) {
    return (e = new RegExp('^[^#]*[?&]' + e + '=([^&#]*)').exec(n))
      ? decodeURIComponent(e[1].replace(/\+/g, ' '))
      : null;
  }
  function M(e, n, t, o, r, i, a) {
    return 1 < arguments.length
      ? (document.cookie =
          e +
          '=' +
          encodeURIComponent(null != n ? n : '') +
          (t
            ? '; Expires=' + new Date(+new Date() + 1e3 * t).toUTCString()
            : '') +
          (o ? '; Path=' + o : '') +
          (r ? '; Domain=' + r : '') +
          (i ? '; SameSite=' + i : '') +
          (a ? '; Secure' : ''))
      : decodeURIComponent(
          (('; ' + document.cookie).split('; ' + e + '=')[1] || '').split(
            ';'
          )[0]
        );
  }
  function U(e) {
    return (e = parseInt(e)), isNaN(e) ? void 0 : e;
  }
  function F(e) {
    return (e = parseFloat(e)), isNaN(e) ? void 0 : e;
  }
  function V(e) {
    if (null == e || 'object' != typeof e || Array.isArray(e))
      return function () {
        return !0;
      };
    var n = Object.prototype.hasOwnProperty.call(e, 'allowlist'),
      t = q(e);
    return G(e, function (e) {
      e: {
        var o = 0;
        for (e = H(e); o < e.length; o++)
          if (t[e[o]]) {
            o = !0;
            break e;
          }
        o = !1;
      }
      return o === n;
    });
  }
  function R(e) {
    if (null == e || 'object' != typeof e || Array.isArray(e))
      return function () {
        return !0;
      };
    var n = e.hasOwnProperty('allowlist'),
      t = q(e);
    return G(e, function (e) {
      return e.name in t === n;
    });
  }
  function H(e) {
    return e.className.match(/\S+/g) || [];
  }
  function G(e, n) {
    return e.hasOwnProperty('filter') && e.filter ? e.filter : n;
  }
  function q(e) {
    var n = {};
    if ((e = e.allowlist || e.denylist)) {
      Array.isArray(e) || (e = [e]);
      for (var t = 0; t < e.length; t++) n[e[t]] = !0;
    }
    return n;
  }
  function J(e, n, t, o, r, i, a, c, s, u, l, d, f, m, p, g) {
    function v(e) {
      var n = Object.keys(e)
        .map(function (n) {
          return [n, e[n]];
        })
        .reduce(function (e, n) {
          return (e[n[0]] = n[1].toString()), e;
        }, {});
      return { evt: n, bytes: h(JSON.stringify(n)) };
    }
    function h(e) {
      for (var n = 0, t = 0; t < e.length; t++) {
        var o = e.charCodeAt(t);
        127 >= o
          ? (n += 1)
          : 2047 >= o
          ? (n += 2)
          : 55296 <= o && 57343 >= o
          ? ((n += 4), t++)
          : (n = 65535 > o ? n + 3 : n + 4);
      }
      return n;
    }
    function y(e) {
      for (
        void 0 === e && (e = !1);
        x.length && 'string' != typeof x[0] && 'object' != typeof x[0];

      )
        x.shift();
      if (1 > x.length) O = !1;
      else {
        if (!_ || 'string' != typeof _.valueOf())
          throw 'No collector configured';
        if (((O = !0), j)) {
          var n = function (e) {
              for (
                var n = 0, t = 0;
                n < e.length && !((t += e[n].bytes) >= a);

              )
                n += 1;
              return n;
            },
            o = void 0;
          if (z(x))
            var r = w((o = _), !0, e),
              i = n(x);
          else (o = A(x[0])), (r = w(o, !1, e)), (i = 1);
          var c = setTimeout(function () {
              r.abort(), (O = !1);
            }, l),
            s = function (e) {
              for (var n = 0; n < e; n++) x.shift();
              t && S(D, JSON.stringify(x.slice(0, u)));
            };
          if (
            ((r.onreadystatechange = function () {
              if (4 === r.readyState && 200 <= r.status)
                if ((clearTimeout(c), 300 > r.status)) s(i), y();
                else {
                  var e = r.status;
                  (e =
                    !(200 <= e && 300 > e) &&
                    (!!p.includes(e) || !g.includes(e))) ||
                    (We.error('Status '.concat(r.status, ', will not retry.')),
                    s(i)),
                    (O = !1);
                }
            }),
            z(x))
          ) {
            if (0 < (n = x.slice(0, i)).length) {
              if (
                ((e = !1),
                (n = n.map(function (e) {
                  return e.evt;
                })),
                I)
              ) {
                var f = new Blob([k(b(n))], { type: 'application/json' });
                try {
                  e = navigator.sendBeacon(o, f);
                } catch (n) {
                  e = !1;
                }
              }
              !0 === e ? (s(i), y()) : r.send(k(b(n)));
            }
          } else r.send();
        } else if (d || z(x)) O = !1;
        else {
          o = new Image(1, 1);
          var m = !0;
          (o.onload = function () {
            m &&
              ((m = !1),
              x.shift(),
              t && S(D, JSON.stringify(x.slice(0, u))),
              y());
          }),
            (o.onerror = function () {
              m && (O = m = !1);
            }),
            (o.src = A(x[0])),
            setTimeout(function () {
              m && O && ((m = !1), y());
            }, l);
        }
      }
    }
    function w(e, n, t) {
      var o = new XMLHttpRequest();
      for (var r in (n
        ? (o.open('POST', e, !t),
          o.setRequestHeader('Content-Type', 'application/json; charset=UTF-8'))
        : o.open('GET', e, !t),
      (o.withCredentials = m),
      d && o.setRequestHeader('SP-Anonymous', '*'),
      f))
        Object.prototype.hasOwnProperty.call(f, r) &&
          o.setRequestHeader(r, f[r]);
      return o;
    }
    function k(e) {
      return JSON.stringify({
        schema:
          'iglu:com.snowplowanalytics.snowplow/payload_data/jsonschema/1-0-4',
        data: e,
      });
    }
    function b(e) {
      for (var n = new Date().getTime().toString(), t = 0; t < e.length; t++)
        e[t].stm = n;
      return e;
    }
    function A(e) {
      return s
        ? _ + e.replace('?', '?stm=' + new Date().getTime() + '&')
        : _ + e;
    }
    var _,
      P,
      T,
      C,
      O = !1,
      x = [],
      E =
        !0 === (o = 'string' == typeof o ? o.toLowerCase() : o) ||
        'beacon' === o ||
        'true' === o,
      I =
        !(
          !(E && window.navigator && window.navigator.sendBeacon) ||
          ((P = window.navigator.userAgent),
          ((C = (C = P).match('(iP.+; CPU .*OS (d+)[_d]*.*) AppleWebKit/')) &&
            C.length &&
            parseInt(C[0]) <= 13) ||
            ((function (e, n, t) {
              return (
                !(
                  !(t = t.match(
                    '(Macintosh;.*Mac OS X (d+)_(d+)[_d]*.*) AppleWebKit/'
                  )) || !t.length
                ) &&
                (parseInt(t[0]) <= e ||
                  (parseInt(t[0]) === e && parseInt(t[1]) <= n))
              );
            })(10, 15, P) &&
              (T = P).match('Version/.* Safari/') &&
              !T.match('Chrom(e|ium)')))
        ) && E,
      j = !(
        !window.XMLHttpRequest || !('withCredentials' in new XMLHttpRequest())
      ),
      N = 'get' !== o && j && ('post' === o || E),
      L = N ? r : '/i',
      D = 'snowplowOutQueue_'.concat(e, '_').concat(N ? 'post2' : 'get');
    if (
      (E && (f = {}),
      (i =
        (t &&
          (function () {
            try {
              var e = !!window.localStorage;
            } catch (n) {
              e = !0;
            }
            if (!e) return !1;
            try {
              var n = window.localStorage;
              return (
                n.setItem('modernizr', 'modernizr'),
                n.removeItem('modernizr'),
                !0
              );
            } catch (e) {
              return !1;
            }
          })() &&
          N &&
          i) ||
        1),
      t)
    )
      try {
        var B = window.localStorage.getItem(D);
        x = B ? JSON.parse(B) : [];
      } catch (P) {}
    Array.isArray(x) || (x = []),
      n.outQueues.push(x),
      j &&
        1 < i &&
        n.bufferFlushers.push(function (e) {
          O || y(e);
        });
    var z = function (e) {
      return 'object' == typeof e[0];
    };
    return {
      enqueueRequest: function (e, n) {
        if (((_ = n + L), N)) {
          if ((e = v(e)).bytes >= a)
            return (
              We.warn('Event (' + e.bytes + 'B) too big, max is ' + a),
              (n = e),
              void w(_, !0, !1).send(k(b([n.evt])))
            );
          x.push(e);
        } else {
          var o,
            s = '?',
            l = { co: !0, cx: !0 },
            d = !0;
          for (o in e)
            e.hasOwnProperty(o) &&
              !l.hasOwnProperty(o) &&
              (d ? (d = !1) : (s += '&'),
              (s += encodeURIComponent(o) + '=' + encodeURIComponent(e[o])));
          for (var f in l)
            e.hasOwnProperty(f) &&
              l.hasOwnProperty(f) &&
              (s += '&' + f + '=' + encodeURIComponent(e[f]));
          if (0 < c && (l = h((l = A(s)))) >= c)
            return (
              We.warn('Event (' + l + 'B) too big, max is ' + c),
              void (j && ((e = v(e)), w(n + r, !0, !1).send(k(b([e.evt])))))
            );
          x.push(s);
        }
        (n = !1),
          t && (n = S(D, JSON.stringify(x.slice(0, u)))),
          O || (n && !(x.length >= i)) || y();
      },
      executeQueue: function () {
        O || y();
      },
      setUseLocalStorage: function (e) {
        t = e;
      },
      setAnonymousTracking: function (e) {
        d = e;
      },
      setCollectorUrl: function (e) {
        _ = e + L;
      },
      setBufferSize: function (e) {
        i = e;
      },
    };
  }
  function Y(e, n, t) {
    return (
      'translate.googleusercontent.com' === e
        ? ('' === t && (t = n),
          (e = N(
            (n =
              null !=
              (e =
                (e = /^(?:https?|ftp)(?::\/*(?:[^?]+))([?][^#]+)/.exec(n)) &&
                1 < (null == e ? void 0 : e.length)
                  ? z('u', e[1])
                  : null)
                ? e
                : '')
          )))
        : ('cc.bingj.com' !== e && 'webcache.googleusercontent.com' !== e) ||
          (e = N((n = document.links[0].href))),
      [e, n, t]
    );
  }
  function K(e, n) {
    return (
      void 0 === n && (n = { memorizedVisitCount: 1 }),
      (n = n.memorizedVisitCount),
      '0' === e[0] ? ((e[7] = e[6]), (e[5] = e[4]), e[3]++) : (e[3] = n),
      (n = Ye.v4()),
      (e[6] = n),
      (e[10] = 0),
      (e[8] = ''),
      (e[9] = void 0),
      n
    );
  }
  function W(e) {
    e[4] = Math.round(new Date().getTime() / 1e3);
  }
  function X(e, n, t) {
    var o = e[9];
    return {
      userId: t ? '00000000-0000-0000-0000-000000000000' : e[1],
      sessionId: e[6],
      eventIndex: e[10],
      sessionIndex: e[3],
      previousSessionId: t ? null : e[7] || null,
      storageMechanism: 'localStorage' == n ? 'LOCAL_STORAGE' : 'COOKIE_1',
      firstEventId: e[8] || null,
      firstEventTimestamp: o ? new Date(o).toISOString() : null,
    };
  }
  function Q() {
    var e = Z;
    if ('innerWidth' in window)
      var n = window.innerWidth,
        t = window.innerHeight;
    else
      (n = (t = document.documentElement || document.body).clientWidth),
        (t = t.clientHeight);
    (e = e(0 <= n && 0 <= t ? n + 'x' + t : null)), (n = Z);
    var o = document.documentElement,
      r = document.body;
    return (
      (t = Math.max(o.clientWidth, o.offsetWidth, o.scrollWidth)),
      (o = Math.max(
        o.clientHeight,
        o.offsetHeight,
        o.scrollHeight,
        r ? Math.max(r.offsetHeight, r.scrollHeight) : 0
      )),
      {
        viewport: e,
        documentSize: n((t = isNaN(t) || isNaN(o) ? '' : t + 'x' + o)),
        resolution: Z(screen.width + 'x' + screen.height),
        colorDepth: screen.colorDepth,
        devicePixelRatio: window.devicePixelRatio,
        cookiesEnabled: window.navigator.cookieEnabled,
        online: window.navigator.onLine,
        browserLanguage: navigator.language || navigator.userLanguage,
        documentLanguage: document.documentElement.lang,
        webdriver: window.navigator.webdriver,
        deviceMemory: window.navigator.deviceMemory,
        hardwareConcurrency: window.navigator.hardwareConcurrency,
      }
    );
  }
  function Z(e) {
    return (
      e &&
      e
        .split('x')
        .map(function (e) {
          return Math.floor(Number(e));
        })
        .join('x')
    );
  }
  function $(e, n, o, r, i, a) {
    void 0 === a && (a = {});
    var c = [];
    e = (function (e, n, o, r, i, a) {
      function s() {
        (Ze = Y(window.location.hostname, window.location.href, D()))[1] !==
          en && (nn = D(en)),
          ($e = L(Ze[0])),
          (en = Ze[1]);
      }
      function u(e) {
        var n = new Date().getTime();
        if (null != (e = e.currentTarget) && e.href) {
          n = '_sp=' + Ge + '.' + n;
          var t = e.href.split('#'),
            o = t[0].split('?'),
            r = o.shift();
          if ((o = o.join('?'))) {
            for (var i = !0, a = o.split('&'), c = 0; c < a.length; c++)
              if ('_sp=' === a[c].substr(0, 4)) {
                (i = !1), (a[c] = n), (o = a.join('&'));
                break;
              }
            i && (o = n + '&' + o);
          } else o = n;
          (t[0] = r + '?' + o), (n = t.join('#')), (e.href = n);
        }
      }
      function l(e) {
        for (var n = 0; n < document.links.length; n++) {
          var t = document.links[n];
          !t.spDecorationEnabled &&
            e(t) &&
            (B(t, 'click', u, !0),
            B(t, 'mousedown', u, !0),
            (t.spDecorationEnabled = !0));
        }
      }
      function d(e) {
        if (De) {
          var n = /#.*/;
          e = e.replace(n, '');
        }
        return Be && ((n = /[{}]/g), (e = e.replace(n, ''))), e;
      }
      function f(e) {
        return (e = /^([a-z]+):/.exec(e)) ? e[1] : null;
      }
      function m(e) {
        if (((e = ln + e + '.' + He), 'localStorage' == An)) {
          try {
            var n = window.localStorage,
              t = n.getItem(e + '.expires');
            if (null === t || +t > Date.now()) var o = n.getItem(e);
            else n.removeItem(e), n.removeItem(e + '.expires'), (o = void 0);
          } catch (e) {
            o = void 0;
          }
          return o;
        }
        if ('cookie' == An || 'cookieAndLocalStorage' == An) return M(e);
      }
      function p() {
        s(), (He = tn((dn || $e) + (fn || '/')).slice(0, 4));
      }
      function g() {
        Me = new Date().getTime();
      }
      function v() {
        var e = h(),
          n = e[0];
        n < Ue ? (Ue = n) : n > Fe && (Fe = n),
          (e = e[1]) < Ve ? (Ve = e) : e > Re && (Re = e),
          g();
      }
      function h() {
        var e = document.documentElement;
        return e
          ? [
              e.scrollLeft || window.pageXOffset,
              e.scrollTop || window.pageYOffset,
            ]
          : [0, 0];
      }
      function y() {
        var e = h(),
          n = e[0];
        (Fe = Ue = n), (Re = Ve = e = e[1]);
      }
      function w() {
        return b(ln + 'ses.' + He, '*', yn);
      }
      function k(e) {
        var n = ln + 'id.' + He;
        return e.shift(), b(n, (e = e.join('.')), hn);
      }
      function b(e, n, t) {
        return (
          !(bn && !wn) &&
          ('localStorage' == An
            ? S(e, n, t)
            : ('cookie' == An || 'cookieAndLocalStorage' == An) &&
              (M(e, n, t, fn, dn, mn, pn),
              -1 !== document.cookie.indexOf(''.concat(e, '='))))
        );
      }
      function A(e) {
        var n = ln + 'id.' + He,
          t = ln + 'ses.' + He;
        O(n),
          O(t),
          M(n, '', -1, '/', dn, mn, pn),
          M(t, '', -1, '/', dn, mn, pn),
          (null != e && e.preserveSession) || ((qe = Ye.v4()), (Pn = 1)),
          (null != e && e.preserveUser) ||
            ((Ge = bn ? '' : Ye.v4()), (Je = null));
      }
      function P(e) {
        e &&
          e.stateStorageStrategy &&
          ((a.stateStorageStrategy = e.stateStorageStrategy), (An = Ce(a))),
          (bn = !!a.anonymousTracking),
          (wn = Se(a)),
          (kn = Oe(a)),
          Tn.setUseLocalStorage(
            'localStorage' == An || 'cookieAndLocalStorage' == An
          ),
          Tn.setAnonymousTracking(kn);
      }
      function T() {
        if (!bn || wn) {
          var e = 'none' != An && !!m('ses'),
            n = C();
          if (n[1]) var t = n[1];
          else (t = bn ? '' : Ye.v4()), (n[1] = t);
          (Ge = t),
            (qe = e ? n[6] : K(n)),
            (Pn = n[3]),
            'none' != An && (w(), W(n), k(n));
        }
      }
      function C() {
        return 'none' == An
          ? ['1', '', 0, 0, 0, void 0, '', '', '', void 0, 0]
          : (function (e, n, t, o) {
              var r = Math.round(new Date().getTime() / 1e3);
              e
                ? (e = e.split('.')).unshift('0')
                : (e = ['1', n, r, o, r, '', t]),
                (e[6] && 'undefined' !== e[6]) || (e[6] = Ye.v4()),
                (e[7] && 'undefined' !== e[7]) || (e[7] = ''),
                (e[8] && 'undefined' !== e[8]) || (e[8] = ''),
                (e[9] && 'undefined' !== e[9]) || (e[9] = ''),
                (e[10] && 'undefined' !== e[10]) || (e[10] = 0);
              var i = function (e, n) {
                return (e = parseInt(e)), isNaN(e) ? n : e;
              };
              return (
                (n = function (e) {
                  return e ? i(e, void 0) : void 0;
                }),
                [
                  e[0],
                  e[1],
                  i(e[2], r),
                  i(e[3], o),
                  i(e[4], r),
                  n(e[5]),
                  e[6],
                  e[7],
                  e[8],
                  n(e[9]),
                  i(e[10], 0),
                ]
              );
            })(m('id') || void 0, Ge, qe, Pn);
      }
      function I(e) {
        return 0 === e.indexOf('http')
          ? e
          : ('https:' === document.location.protocol ? 'https' : 'http') +
              '://' +
              e;
      }
      function U() {
        (Cn && null != i.pageViewId) || (i.pageViewId = Ye.v4());
      }
      function F() {
        return null == i.pageViewId && (i.pageViewId = Ye.v4()), i.pageViewId;
      }
      function V() {
        if ('none' === An || bn || !Ie) return null;
        var e = x('_sp_tab_id');
        if (!e) {
          e = Ye.v4();
          try {
            window.sessionStorage.setItem('_sp_tab_id', e);
          } catch (e) {}
          e = x('_sp_tab_id');
        }
        return e || null;
      }
      function R(e) {
        var n = e.title,
          o = e.context,
          r = e.timestamp;
        if (
          ((e = e.contextCallback),
          s(),
          Sn && U(),
          (Sn = !0),
          (sn = document.title),
          (n = j((Le = n) || sn)),
          Xe.track(
            (function (e) {
              var n = e.pageUrl,
                o = e.pageTitle;
              e = e.referrer;
              var r = t();
              return (
                r.add('e', 'pv'),
                r.add('url', n),
                r.add('page', o),
                r.add('refr', e),
                r
              );
            })({ pageUrl: d(Ne || en), pageTitle: n, referrer: d(je || nn) }),
            (o || []).concat(e ? e() : []),
            r
          ),
          (r = new Date()),
          (n = !1),
          On.enabled && !On.installed)
        ) {
          n = On.installed = !0;
          var i = {
            update: function () {
              if (
                'undefined' != typeof window &&
                'function' == typeof window.addEventListener
              ) {
                var e = !1,
                  n = Object.defineProperty({}, 'passive', {
                    get: function () {
                      e = !0;
                    },
                    set: function () {},
                  }),
                  t = function () {};
                window.addEventListener('testPassiveEventSupport', t, n),
                  window.removeEventListener('testPassiveEventSupport', t, n),
                  (i.hasSupport = e);
              }
            },
          };
          i.update();
          var a =
            'onwheel' in document.createElement('div')
              ? 'wheel'
              : void 0 !== document.onmousewheel
              ? 'mousewheel'
              : 'DOMMouseScroll';
          Object.prototype.hasOwnProperty.call(i, 'hasSupport')
            ? B(document, a, g, { passive: !0 })
            : B(document, a, g),
            y(),
            (a = function (e, n) {
              return (
                void 0 === n && (n = g),
                function (e) {
                  return B(document, e, n);
                }
              );
            }),
            'click mouseup mousedown mousemove keypress keydown keyup touchend touchstart'
              .split(' ')
              .forEach(a(document)),
            ['resize', 'focus', 'blur'].forEach(a(window)),
            a(window, v)('scroll');
        }
        if (On.enabled && (un || n))
          for (r in ((Me = r.getTime()), (r = void 0), On.configurations))
            (n = On.configurations[r]) &&
              (window.clearInterval(n.activityInterval), H(n, o, e));
      }
      function H(e, n, t) {
        var o = function (e, n) {
            s(),
              e({
                context: n,
                pageViewId: F(),
                minXOffset: Ue,
                minYOffset: Ve,
                maxXOffset: Fe,
                maxYOffset: Re,
              }),
              y();
          },
          r = function () {
            Me + e.configHeartBeatTimer > new Date().getTime() &&
              o(e.callback, (n || []).concat(t ? t() : []));
          };
        e.activityInterval =
          0 != e.configMinimumVisitLength
            ? window.setTimeout(function () {
                Me + e.configMinimumVisitLength > new Date().getTime() &&
                  o(e.callback, (n || []).concat(t ? t() : [])),
                  (e.activityInterval = window.setInterval(
                    r,
                    e.configHeartBeatTimer
                  ));
              }, e.configMinimumVisitLength)
            : window.setInterval(r, e.configHeartBeatTimer);
      }
      function G(e) {
        var n = e.minimumVisitLength,
          t = e.heartbeatDelay;
        if (((e = e.callback), E(n) && E(t)))
          return {
            configMinimumVisitLength: 1e3 * n,
            configHeartBeatTimer: 1e3 * t,
            callback: e,
          };
        We.error(
          'Activity tracking minimumVisitLength & heartbeatDelay must be integers'
        );
      }
      function q(e) {
        var n = e.context,
          o = e.minXOffset,
          r = e.minYOffset,
          i = e.maxXOffset,
          a = e.maxYOffset;
        (e = document.title) !== sn && ((sn = e), (Le = void 0));
        var c = (e = Xe).track,
          s = d(Ne || en),
          u = j(Le || sn),
          l = d(je || nn);
        (o = Math.round(o)),
          (i = Math.round(i)),
          (r = Math.round(r)),
          (a = Math.round(a));
        var f = t();
        f.add('e', 'pp'),
          f.add('url', s),
          f.add('page', u),
          f.add('refr', l),
          o && !isNaN(Number(o)) && f.add('pp_mix', o.toString()),
          i && !isNaN(Number(i)) && f.add('pp_max', i.toString()),
          r && !isNaN(Number(r)) && f.add('pp_miy', r.toString()),
          a && !isNaN(Number(a)) && f.add('pp_may', a.toString()),
          c.call(e, f, n);
      }
      var Z,
        $,
        ee,
        ne,
        te,
        oe,
        re,
        ie,
        ae,
        ce,
        se,
        ue,
        le,
        de,
        fe,
        me,
        pe,
        ge,
        ve,
        he,
        ye,
        we,
        ke,
        be,
        Ae,
        _e,
        Pe,
        Te;
      a.eventMethod = null !== (Z = a.eventMethod) && void 0 !== Z ? Z : 'post';
      var Ce = function (e) {
          var n;
          return null !== (n = e.stateStorageStrategy) && void 0 !== n
            ? n
            : 'cookieAndLocalStorage';
        },
        Se = function (e) {
          var n, t;
          return (
            'boolean' != typeof e.anonymousTracking &&
            null !==
              (t =
                !0 ===
                (null === (n = e.anonymousTracking) || void 0 === n
                  ? void 0
                  : n.withSessionTracking)) &&
            void 0 !== t &&
            t
          );
        },
        Oe = function (e) {
          var n, t;
          return (
            'boolean' != typeof e.anonymousTracking &&
            null !==
              (t =
                !0 ===
                (null === (n = e.anonymousTracking) || void 0 === n
                  ? void 0
                  : n.withServerAnonymisation)) &&
            void 0 !== t &&
            t
          );
        },
        xe =
          null !==
            (ee =
              null === ($ = null == a ? void 0 : a.contexts) || void 0 === $
                ? void 0
                : $.browser) &&
          void 0 !== ee &&
          ee,
        Ie =
          null ===
            (te =
              null === (ne = null == a ? void 0 : a.contexts) || void 0 === ne
                ? void 0
                : ne.webPage) ||
          void 0 === te ||
          te;
      c.push({
        beforeTrack: function (e) {
          var n = m('ses'),
            t = C(),
            o = 0 === t[10];
          if (((Ke = !!ze && !!M(ze)), vn || Ke)) A();
          else {
            if (
              ('0' === t[0]
                ? ((qe = n || 'none' == An ? t[6] : K(t)), (Pn = t[3]))
                : new Date().getTime() - _n > 1e3 * yn &&
                  (Pn++, (qe = K(t, { memorizedVisitCount: Pn }))),
              W(t),
              0 === t[10])
            ) {
              var r = e.build();
              (t[8] = r.eid),
                (r = r.dtm || r.ttm),
                (t[9] = r ? parseInt(r) : void 0);
            }
            t[10] += 1;
            var i = (r = Q()).documentSize;
            e.add('vp', r.viewport),
              e.add('ds', i),
              e.add('vid', wn ? Pn : bn ? null : Pn),
              e.add('sid', wn ? qe : bn ? null : qe),
              e.add('duid', bn ? null : t[1]),
              e.add('uid', bn ? null : Je),
              s(),
              e.add('refr', d(je || nn)),
              e.add('url', d(Ne || en)),
              (r = X(t, An, bn)),
              !xn ||
                (bn && !wn) ||
                e.addContextEntity({
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/client_session/jsonschema/1-0-2',
                  data: r,
                }),
              'none' != An &&
                (k(t),
                (e = w()),
                (n && !o) || !e || !En || In || (En(r), (In = !1))),
              (_n = new Date().getTime());
          }
        },
      }),
        Ie &&
          c.push({
            contexts: function () {
              return [
                {
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/web_page/jsonschema/1-0-0',
                  data: { id: F() },
                },
              ];
            },
          }),
        xe &&
          c.push({
            contexts: function () {
              return [
                {
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/browser_context/jsonschema/1-0-0',
                  data: Ee(Ee({}, Q()), { tabId: V() }),
                },
              ];
            },
          }),
        c.push.apply(c, null !== (oe = a.plugins) && void 0 !== oe ? oe : []);
      var je,
        Ne,
        Le,
        De,
        Be,
        ze,
        Me,
        Ue,
        Fe,
        Ve,
        Re,
        He,
        Ge,
        qe,
        Je,
        Ke,
        Xe = _({
          base64: a.encodeBase64,
          corePlugins: c,
          callback: function (e) {
            vn || Ke || Tn.enqueueRequest(e.build(), rn);
          },
        }),
        Qe = document.characterSet || document.charset,
        Ze = Y(window.location.hostname, window.location.href, D()),
        $e = L(Ze[0]),
        en = Ze[1],
        nn = Ze[2],
        on = null !== (re = a.platform) && void 0 !== re ? re : 'web',
        rn = I(r),
        an =
          null !== (ie = a.postPath) && void 0 !== ie
            ? ie
            : '/com.snowplowanalytics.snowplow/tp2',
        cn = null !== (ae = a.appId) && void 0 !== ae ? ae : '',
        sn = document.title,
        un =
          null === (ce = a.resetActivityTrackingOnPageView) ||
          void 0 === ce ||
          ce,
        ln = null !== (se = a.cookieName) && void 0 !== se ? se : '_sp_',
        dn = null !== (ue = a.cookieDomain) && void 0 !== ue ? ue : void 0,
        fn = '/',
        mn = null !== (le = a.cookieSameSite) && void 0 !== le ? le : 'None',
        pn = null === (de = a.cookieSecure) || void 0 === de || de,
        gn =
          navigator.doNotTrack || navigator.msDoNotTrack || window.doNotTrack,
        vn =
          void 0 !== a.respectDoNotTrack &&
          a.respectDoNotTrack &&
          ('yes' === gn || '1' === gn),
        hn = null !== (fe = a.cookieLifetime) && void 0 !== fe ? fe : 63072e3,
        yn =
          null !== (me = a.sessionCookieTimeout) && void 0 !== me ? me : 1800,
        wn = Se(a),
        kn = Oe(a),
        bn = !!a.anonymousTracking,
        An = Ce(a),
        _n = new Date().getTime(),
        Pn = 1,
        Tn = J(
          e,
          i,
          'localStorage' == An || 'cookieAndLocalStorage' == An,
          a.eventMethod,
          an,
          null !== (pe = a.bufferSize) && void 0 !== pe ? pe : 1,
          null !== (ge = a.maxPostBytes) && void 0 !== ge ? ge : 4e4,
          null !== (ve = a.maxGetBytes) && void 0 !== ve ? ve : 0,
          null === (he = a.useStm) || void 0 === he || he,
          null !== (ye = a.maxLocalStorageQueueSize) && void 0 !== ye
            ? ye
            : 1e3,
          null !== (we = a.connectionTimeout) && void 0 !== we ? we : 5e3,
          kn,
          null !== (ke = a.customHeaders) && void 0 !== ke ? ke : {},
          null === (be = a.withCredentials) || void 0 === be || be,
          null !== (Ae = a.retryStatusCodes) && void 0 !== Ae ? Ae : [],
          (null !== (_e = a.dontRetryStatusCodes) && void 0 !== _e
            ? _e
            : []
          ).concat([400, 401, 403, 410, 422])
        ),
        Cn = !1,
        Sn = !1,
        On = { enabled: !1, installed: !1, configurations: {} },
        xn =
          null !==
            (Te =
              null === (Pe = a.contexts) || void 0 === Pe
                ? void 0
                : Pe.session) &&
          void 0 !== Te &&
          Te,
        En = a.onSessionUpdateCallback,
        In = !1;
      a.hasOwnProperty('discoverRootDomain') &&
        a.discoverRootDomain &&
        (dn = (function (e, n) {
          for (
            var t = window.location.hostname,
              o = '_sp_root_domain_test_' + new Date().getTime(),
              r = '_test_value_' + new Date().getTime(),
              i = t.split('.'),
              a = i.length - 2;
            0 <= a;
            a--
          ) {
            var c = i.slice(a).join('.');
            if ((M(o, r, 0, '/', c, e, n), M(o) === r)) {
              for (
                M(o, '', -1, '/', c, e, n),
                  t = document.cookie.split('; '),
                  o = [],
                  r = 0;
                r < t.length;
                r++
              )
                '_sp_root_domain_test_' === t[r].substring(0, 21) &&
                  o.push(t[r]);
              for (t = o, o = 0; o < t.length; o++)
                M(t[o], '', -1, '/', c, e, n);
              return c;
            }
          }
          return t;
        })(mn, pn));
      var jn = Q(),
        Nn = jn.browserLanguage,
        Ln = jn.resolution,
        Dn = jn.colorDepth,
        Bn = jn.cookiesEnabled;
      return (
        Xe.setTrackerVersion(o),
        Xe.setTrackerNamespace(n),
        Xe.setAppId(cn),
        Xe.setPlatform(on),
        Xe.addPayloadPair('cookie', Bn ? '1' : '0'),
        Xe.addPayloadPair('cs', Qe),
        Xe.addPayloadPair('lang', Nn),
        Xe.addPayloadPair('res', Ln),
        Xe.addPayloadPair('cd', Dn),
        p(),
        T(),
        a.crossDomainLinker && l(a.crossDomainLinker),
        Ee(
          Ee(
            {},
            {
              getDomainSessionIndex: function () {
                return Pn;
              },
              getPageViewId: F,
              getTabId: V,
              newSession: function () {
                var e = C();
                if (
                  ('0' === e[0]
                    ? ((qe = 'none' != An ? K(e) : e[6]), (Pn = e[3]))
                    : (Pn++, (qe = K(e, { memorizedVisitCount: Pn }))),
                  W(e),
                  'none' != An)
                ) {
                  var n = X(e, An, bn);
                  k(e), w() && En && ((In = !0), En(n));
                }
                _n = new Date().getTime();
              },
              getCookieName: function (e) {
                return ln + e + '.' + He;
              },
              getUserId: function () {
                return Je;
              },
              getDomainUserId: function () {
                return C()[1];
              },
              getDomainUserInfo: function () {
                return C();
              },
              setReferrerUrl: function (e) {
                je = e;
              },
              setCustomUrl: function (e) {
                s();
                var n,
                  t = en;
                f(e)
                  ? (Ne = e)
                  : '/' === e.slice(0, 1)
                  ? (Ne = f(t) + '://' + N(t) + e)
                  : (0 <= (n = (t = d(t)).indexOf('?')) && (t = t.slice(0, n)),
                    (n = t.lastIndexOf('/')) !== t.length - 1 &&
                      (t = t.slice(0, n + 1)),
                    (Ne = t + e));
              },
              setDocumentTitle: function (e) {
                (sn = document.title), (Le = e);
              },
              discardHashTag: function (e) {
                De = e;
              },
              discardBrace: function (e) {
                Be = e;
              },
              setCookiePath: function (e) {
                (fn = e), p();
              },
              setVisitorCookieTimeout: function (e) {
                hn = e;
              },
              crossDomainLinker: function (e) {
                l(e);
              },
              enableActivityTracking: function (e) {
                On.configurations.pagePing ||
                  ((On.enabled = !0),
                  (On.configurations.pagePing = G(
                    Ee(Ee({}, e), { callback: q })
                  )));
              },
              enableActivityTrackingCallback: function (e) {
                On.configurations.callback ||
                  ((On.enabled = !0), (On.configurations.callback = G(e)));
              },
              updatePageActivity: function () {
                g();
              },
              setOptOutCookie: function (e) {
                ze = e;
              },
              setUserId: function (e) {
                Je = e;
              },
              setUserIdFromLocation: function (e) {
                s(), (Je = z(e, en));
              },
              setUserIdFromReferrer: function (e) {
                s(), (Je = z(e, nn));
              },
              setUserIdFromCookie: function (e) {
                Je = M(e);
              },
              setCollectorUrl: function (e) {
                (rn = I(e)), Tn.setCollectorUrl(rn);
              },
              setBufferSize: function (e) {
                Tn.setBufferSize(e);
              },
              flushBuffer: function (e) {
                void 0 === e && (e = {}),
                  Tn.executeQueue(),
                  e.newBufferSize && Tn.setBufferSize(e.newBufferSize);
              },
              trackPageView: function (e) {
                void 0 === e && (e = {}), R(e);
              },
              preservePageViewId: function () {
                Cn = !0;
              },
              disableAnonymousTracking: function (e) {
                (a.anonymousTracking = !1), P(e), T(), Tn.executeQueue();
              },
              enableAnonymousTracking: function (e) {
                var n;
                (a.anonymousTracking =
                  null === (n = e && (null == e ? void 0 : e.options)) ||
                  void 0 === n ||
                  n),
                  P(e),
                  wn || U();
              },
              clearUserData: A,
            }
          ),
          { id: e, namespace: n, core: Xe, sharedState: i }
        )
      );
    })(e, n, o, r, i, a);
    var s = Ee(Ee({}, e), {
      addPlugin: function (e) {
        var n, t;
        s.core.addPlugin(e),
          null === (t = (n = e.plugin).activateBrowserPlugin) ||
            void 0 === t ||
            t.call(n, s);
      },
    });
    return (
      c.forEach(function (e) {
        var n;
        null === (n = e.activateBrowserPlugin) || void 0 === n || n.call(e, s);
      }),
      s
    );
  }
  function ee(e, n) {
    try {
      oe(null != e ? e : Object.keys(on), on).forEach(n);
    } catch (e) {
      We.error('Function failed', e);
    }
  }
  function ne(e, n, t) {
    try {
      oe(null != e ? e : Object.keys(n), n).forEach(t);
    } catch (e) {
      We.error('Function failed', e);
    }
  }
  function te(e, n, t, o, r, i) {
    return on.hasOwnProperty(e) ? null : ((on[e] = $(e, n, t, o, r, i)), on[e]);
  }
  function oe(e, n) {
    for (var t = [], o = 0; o < e.length; o++) {
      var r = e[o];
      n.hasOwnProperty(r) ? t.push(n[r]) : We.warn(r + ' not configured');
    }
    return t;
  }
  function re() {
    function e() {
      var e;
      if (!n.hasLoaded)
        for (
          n.hasLoaded = !0, e = 0;
          e < n.registeredOnLoadHandlers.length;
          e++
        )
          n.registeredOnLoadHandlers[e]();
      return !0;
    }
    var n = new rn(),
      t = document,
      o = window;
    return (
      t.visibilityState &&
        B(
          t,
          'visibilitychange',
          function () {
            'hidden' == t.visibilityState &&
              n.bufferFlushers.forEach(function (e) {
                e(!1);
              });
          },
          !1
        ),
      B(
        o,
        'beforeunload',
        function () {
          n.bufferFlushers.forEach(function (e) {
            e(!1);
          });
        },
        !1
      ),
      'loading' === document.readyState
        ? (t.addEventListener
            ? t.addEventListener('DOMContentLoaded', function n() {
                t.removeEventListener('DOMContentLoaded', n, !1), e();
              })
            : t.attachEvent &&
              t.attachEvent('onreadystatechange', function n() {
                'complete' === t.readyState &&
                  (t.detachEvent('onreadystatechange', n), e());
              }),
          B(o, 'load', e, !1))
        : e(),
      n
    );
  }
  function ie(e) {
    return Array.isArray(e)
      ? e
      : Object.keys(e).map(function (n) {
          return e[n];
        });
  }
  function ae(e) {
    return {
      activateBrowserPlugin: function () {
        var n;
        en ||
          ((n = navigator).userAgentData &&
            ((en = {
              isMobile: n.userAgentData.mobile,
              brands: ie(n.userAgentData.brands),
            }),
            e &&
              n.userAgentData.getHighEntropyValues &&
              n.userAgentData
                .getHighEntropyValues([
                  'platform',
                  'platformVersion',
                  'architecture',
                  'model',
                  'uaFullVersion',
                ])
                .then(function (e) {
                  (en.architecture = e.architecture),
                    (en.model = e.model),
                    (en.platform = e.platform),
                    (en.uaFullVersion = e.uaFullVersion),
                    (en.platformVersion = e.platformVersion);
                })));
      },
      contexts: function () {
        return en
          ? [
              {
                schema: 'iglu:org.ietf/http_client_hints/jsonschema/1-0-0',
                data: en,
              },
            ]
          : [];
      },
    };
  }
  function ce() {
    function e(e, n) {
      var t = window.optimizely;
      if (t && 'function' == typeof t.get) {
        var o = t.get(e);
        void 0 !== n && void 0 !== o && (o = o[n]);
      }
      return o;
    }
    function n() {
      return ((n = e('state')),
      (t = n && n.getActiveExperimentIds()),
      (o = n && n.getVariationMap()),
      (r = e('visitor')),
      t.map(function (e) {
        var n = o[e],
          t = (n && n.name && n.name.toString()) || null;
        n = n && n.id;
        var i = (r && r.visitorId && r.visitorId.toString()) || null;
        return {
          experimentId: U(e) || null,
          variationName: t,
          variation: U(n) || null,
          visitorId: i,
        };
      })).map(function (e) {
        return {
          schema: 'iglu:com.optimizely.optimizelyx/summary/jsonschema/1-0-0',
          data: e,
        };
      });
      var n, t, o, r;
    }
    return {
      contexts: function () {
        return window.optimizely ? n() : [];
      },
    };
  }
  function se() {
    return {
      contexts: function () {
        var e = window,
          n = (e =
            e.performance ||
            e.mozPerformance ||
            e.msPerformance ||
            e.webkitPerformance).timing;
        return (e = e
          ? [
              {
                schema: 'iglu:org.w3/PerformanceTiming/jsonschema/1-0-0',
                data: {
                  navigationStart: n.navigationStart,
                  redirectStart: n.redirectStart,
                  redirectEnd: n.redirectEnd,
                  fetchStart: n.fetchStart,
                  domainLookupStart: n.domainLookupStart,
                  domainLookupEnd: n.domainLookupEnd,
                  connectStart: n.connectStart,
                  secureConnectionStart: n.secureConnectionStart,
                  connectEnd: n.connectEnd,
                  requestStart: n.requestStart,
                  responseStart: n.responseStart,
                  responseEnd: n.responseEnd,
                  unloadEventStart: n.unloadEventStart,
                  unloadEventEnd: n.unloadEventEnd,
                  domLoading: n.domLoading,
                  domInteractive: n.domInteractive,
                  domContentLoadedEventStart: n.domContentLoadedEventStart,
                  domContentLoadedEventEnd: n.domContentLoadedEventEnd,
                  domComplete: n.domComplete,
                  loadEventStart: n.loadEventStart,
                  loadEventEnd: n.loadEventEnd,
                  msFirstPaint: n.msFirstPaint,
                  chromeFirstPaint: n.chromeFirstPaint,
                  requestEnd: n.requestEnd,
                  proxyStart: n.proxyStart,
                  proxyEnd: n.proxyEnd,
                },
              },
            ]
          : []);
      },
    };
  }
  function ue() {
    var e;
    return {
      activateBrowserPlugin: function (n) {
        (e = n.id), (pn[n.id] = n);
      },
      contexts: function () {
        return gn[e]
          ? [
              {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/gdpr/jsonschema/1-0-0',
                data: gn[e],
              },
            ]
          : [];
      },
      logger: function (e) {
        dn = e;
      },
    };
  }
  function le(e) {
    var n;
    return (
      void 0 === e && (e = !1),
      {
        activateBrowserPlugin: function (t) {
          (n = t.id), (hn[t.id] = [!1, void 0]), e && de([n]);
        },
        contexts: function () {
          var e,
            t = null === (e = hn[n]) || void 0 === e ? void 0 : e[1];
          return t ? [t] : [];
        },
      }
    );
  }
  function de(e) {
    void 0 === e && (e = Object.keys(hn));
    var n = navigator;
    e.forEach(function (e) {
      hn[e] = [!0, fn];
    }),
      !yn &&
        n.geolocation &&
        n.geolocation.getCurrentPosition &&
        ((yn = !0),
        n.geolocation.getCurrentPosition(function (e) {
          var n = e.coords;
          for (var t in ((fn = {
            schema:
              'iglu:com.snowplowanalytics.snowplow/geolocation_context/jsonschema/1-1-0',
            data: {
              latitude: n.latitude,
              longitude: n.longitude,
              latitudeLongitudeAccuracy: n.accuracy,
              altitude: n.altitude,
              altitudeAccuracy: n.altitudeAccuracy,
              bearing: n.heading,
              speed: n.speed,
              timestamp: Math.round(e.timestamp),
            },
          }),
          hn))
            Object.prototype.hasOwnProperty.call(hn, t) &&
              hn[t][0] &&
              (hn[t] = [!0, fn]);
        }));
  }
  function fe() {
    return {
      contexts: function () {
        var e = {
          schema: 'iglu:com.google.analytics/cookies/jsonschema/1-0-0',
          data: {},
        };
        return (
          '__utma __utmb __utmc __utmv __utmz _ga'
            .split(' ')
            .forEach(function (n) {
              var t = M(n);
              t && (e.data[n] = t);
            }),
          [e]
        );
      },
    };
  }
  function me() {
    return {
      activateBrowserPlugin: function (e) {
        bn[e.id] = e;
      },
    };
  }
  function pe(e, n, t) {
    for (
      var o, r, i, a;
      null !== (o = n.parentElement) &&
      null != o &&
      'A' !== (r = n.tagName.toUpperCase()) &&
      'AREA' !== r;

    )
      n = o;
    if (null != (o = n).href) {
      i = (r = o.hostname || N(o.href)).toLowerCase();
      var s = o.href.replace(r, i);
      /^(javascript|vbscript|jscript|mocha|livescript|ecmascript|mailto):/i.test(
        s
      ) ||
        ((r = o.id),
        (i = H(o)),
        (a = o.target),
        (o = An[e.id].linkTrackingContent ? o.innerHTML : void 0),
        (s = unescape(s)),
        e.core.track(
          T({
            targetUrl: s,
            elementId: r,
            elementClasses: i,
            elementTarget: a,
            elementContent: o,
          }),
          c(t, n)
        ));
    }
  }
  function ge(e, n) {
    return function (t) {
      var o = (t = t || window.event).which || t.button,
        r = t.target || t.srcElement;
      'click' === t.type
        ? r && pe(bn[e], r, n)
        : 'mousedown' === t.type
        ? (1 !== o && 2 !== o) || !r
          ? (An[e].lastButton = An[e].lastTarget = null)
          : ((An[e].lastButton = o), (An[e].lastTarget = r))
        : 'mouseup' === t.type &&
          (o === An[e].lastButton && r === An[e].lastTarget && pe(bn[e], r, n),
          (An[e].lastButton = An[e].lastTarget = null));
    };
  }
  function ve(e, n) {
    (e = void 0 === e ? {} : e),
      (An[n] = {
        linkTrackingContent: e.trackContent,
        linkTrackingContext: e.context,
        linkTrackingPseudoClicks: e.pseudoClicks,
        linkTrackingFilter: V(e.options),
      });
  }
  function he(e) {
    var n,
      t,
      o,
      r = document.links;
    for (o = 0; o < r.length; o++)
      if (
        null !== (t = (n = An[e]).linkTrackingFilter) &&
        void 0 !== t &&
        t.call(n, r[o]) &&
        !r[o][e]
      ) {
        var i = e,
          a = r[o];
        An[i].linkTrackingPseudoClicks
          ? (B(a, 'mouseup', ge(i, An[i].linkTrackingContext), !1),
            B(a, 'mousedown', ge(i, An[i].linkTrackingContext), !1))
          : B(a, 'click', ge(i, An[i].linkTrackingContext), !1),
          (r[o][e] = !0);
      }
  }
  function ye(e, n) {
    var t,
      o = n.context,
      r = e.id + 'form',
      i = (function (e) {
        if (e) {
          var n = function (e) {
              return !0;
            },
            t = null;
          return (
            !(function (e) {
              return null != e && 0 < Array.prototype.slice.call(e).length;
            })(e.forms)
              ? (n = V(e.forms))
              : (t = e.forms),
            {
              forms: t,
              formFilter: n,
              fieldFilter: R(e.fields),
              fieldTransform: we(e.fields),
              eventFilter: function (n) {
                var t;
                return (
                  -1 <
                  (null !== (t = e.events) && void 0 !== t ? t : Pn).indexOf(n)
                );
              },
            }
          );
        }
        return {
          forms: null,
          formFilter: function () {
            return !0;
          },
          fieldFilter: function () {
            return !0;
          },
          fieldTransform: Cn,
          eventFilter: function () {
            return !0;
          },
        };
      })(n.options);
    (n =
      null !== (t = i.forms) && void 0 !== t
        ? t
        : document.getElementsByTagName('form')),
      Array.prototype.slice.call(n).forEach(function (n) {
        i.formFilter(n) &&
          (Array.prototype.slice.call(Tn).forEach(function (t) {
            Array.prototype.slice
              .call(n.getElementsByTagName(t))
              .forEach(function (n) {
                i.fieldFilter(n) &&
                  !n[r] &&
                  'password' !== n.type.toLowerCase() &&
                  (i.eventFilter(mn.FOCUS_FORM) &&
                    B(n, 'focus', be(e, i, 'focus_form', o), !1),
                  i.eventFilter(mn.CHANGE_FORM) &&
                    B(n, 'change', be(e, i, 'change_form', o), !1),
                  (n[r] = !0));
              });
          }),
          n[r] ||
            (i.eventFilter(mn.SUBMIT_FORM) &&
              B(
                n,
                'submit',
                (function (e, n, t, o) {
                  return function (r) {
                    var i;
                    r = r.target;
                    var a = (function (e, n) {
                      var t = [];
                      return (
                        Array.prototype.slice.call(Tn).forEach(function (o) {
                          (o = Array.prototype.slice
                            .call(n.getElementsByTagName(o))
                            .filter(function (n) {
                              return n.hasOwnProperty(e);
                            })),
                            Array.prototype.slice.call(o).forEach(function (e) {
                              if ('submit' !== e.type) {
                                var n = {
                                  name: ke(e),
                                  value: e.value,
                                  nodeName: e.nodeName,
                                };
                                e.type &&
                                  'INPUT' === e.nodeName.toUpperCase() &&
                                  (n.type = e.type),
                                  ('checkbox' !== e.type &&
                                    'radio' !== e.type) ||
                                    e.checked ||
                                    (n.value = null),
                                  t.push(n);
                              }
                            });
                        }),
                        t
                      );
                    })(t, r);
                    a.forEach(function (e) {
                      var t;
                      e.value =
                        null !== (t = n.fieldTransform(e.value, e)) &&
                        void 0 !== t
                          ? t
                          : e.value;
                    }),
                      e.core.track(
                        (function (e) {
                          return P({
                            event: {
                              schema:
                                'iglu:com.snowplowanalytics.snowplow/submit_form/jsonschema/1-0-0',
                              data: C({
                                formId: e.formId,
                                formClasses: e.formClasses,
                                elements: e.elements,
                              }),
                            },
                          });
                        })({
                          formId: null !== (i = ke(r)) && void 0 !== i ? i : '',
                          formClasses: H(r),
                          elements: a,
                        }),
                        c(o, r, a)
                      );
                  };
                })(e, i, r, o)
              ),
            (n[r] = !0)));
      });
  }
  function we(e) {
    return e && Object.prototype.hasOwnProperty.call(e, 'transform')
      ? e.transform
      : Cn;
  }
  function ke(e) {
    for (var n = 0, t = ['name', 'id', 'type', 'nodeName']; n < t.length; n++) {
      var o = t[n];
      if (0 != e[o] && 'string' == typeof e[o]) return e[o];
    }
    return null;
  }
  function be(e, n, t, o) {
    return function (r) {
      var i;
      if ((r = r.target)) {
        var a =
            r.nodeName && 'INPUT' === r.nodeName.toUpperCase() ? r.type : null,
          s =
            'checkbox' !== r.type || r.checked
              ? n.fieldTransform(r.value, r)
              : null;
        if ('change_form' === t || ('checkbox' !== a && 'radio' !== a)) {
          var u,
            l = e.core,
            d = l.track;
          for (
            u = r;
            u &&
            u.nodeName &&
            'HTML' !== u.nodeName.toUpperCase() &&
            'FORM' !== u.nodeName.toUpperCase();

          )
            u = u.parentNode;
          u =
            null !=
            (u =
              u && u.nodeName && 'FORM' === u.nodeName.toUpperCase()
                ? ke(u)
                : null)
              ? u
              : '';
          var f = null !== (i = ke(r)) && void 0 !== i ? i : '';
          (i = ''),
            (u = {
              formId: u,
              elementId: f,
              nodeName: r.nodeName,
              elementClasses: H(r),
              value: null != s ? s : null,
            }),
            'change_form' === t
              ? ((i =
                  'iglu:com.snowplowanalytics.snowplow/change_form/jsonschema/1-0-0'),
                (u.type = a))
              : 'focus_form' === t &&
                ((i =
                  'iglu:com.snowplowanalytics.snowplow/focus_form/jsonschema/1-0-0'),
                (u.elementType = a)),
            (i = P({ event: { schema: i, data: C(u, { value: !0 }) } })),
            d.call(l, i, c(o, r, a, s));
        }
      }
    };
  }
  function Ae() {
    return {
      activateBrowserPlugin: function (e) {
        Sn[e.id] = e;
      },
    };
  }
  function _e() {
    return {
      activateBrowserPlugin: function (e) {
        xn[e.id] = e;
      },
    };
  }
  function Pe(e, n) {
    void 0 === n && (n = Object.keys(xn));
    var t = e.message,
      o = e.filename,
      r = e.lineno,
      i = e.colno,
      a = e.error,
      c = e.context,
      s = e.timestamp,
      u = a && a.stack ? a.stack : null;
    ne(n, xn, function (e) {
      e.core.track(
        P({
          event: {
            schema:
              'iglu:com.snowplowanalytics.snowplow/application_error/jsonschema/1-0-1',
            data: {
              programmingLanguage: 'JAVASCRIPT',
              message:
                null != t
                  ? t
                  : "JS Exception. Browser doesn't support ErrorEvent API",
              stackTrace: u,
              lineNumber: r,
              lineColumn: i,
              fileName: o,
            },
          },
        }),
        c,
        s
      );
    });
  }
  function Te() {
    return {
      activateBrowserPlugin: function (e) {
        e.core.setTimezone(
          In.exports.determine('undefined' != typeof Intl).name()
        );
      },
    };
  }
  function Ce() {
    return {
      activateBrowserPlugin: function (e) {
        (Nn[e.id] = e), (Ln[e.id] = { items: [] });
      },
    };
  }
  function Se() {
    return {
      activateBrowserPlugin: function (e) {
        (Bn[e.id] = e), (zn[e.id] = []);
      },
    };
  }
  function Oe() {
    return {
      activateBrowserPlugin: function (e) {
        Un[e.id] = e;
      },
    };
  }
  function xe() {
    return {
      activateBrowserPlugin: function (e) {
        Vn[e.id] = e;
      },
    };
  }
  var Ee = function () {
      return (
        (Ee =
          Object.assign ||
          function (e) {
            for (var n, t = 1, o = arguments.length; t < o; t++)
              for (var r in (n = arguments[t]))
                Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
            return e;
          }),
        Ee.apply(this, arguments)
      );
    },
    Ie = {},
    je =
      ('undefined' != typeof crypto &&
        crypto.getRandomValues &&
        crypto.getRandomValues.bind(crypto)) ||
      ('undefined' != typeof msCrypto &&
        'function' == typeof window.msCrypto.getRandomValues &&
        msCrypto.getRandomValues.bind(msCrypto));
  if (je) {
    var Ne = new Uint8Array(16);
    Ie = function () {
      return je(Ne), Ne;
    };
  } else {
    var Le = Array(16);
    Ie = function () {
      for (var e, n = 0; 16 > n; n++)
        0 == (3 & n) && (e = 4294967296 * Math.random()),
          (Le[n] = (e >>> ((3 & n) << 3)) & 255);
      return Le;
    };
  }
  for (var De = [], Be = 0; 256 > Be; ++Be)
    De[Be] = (Be + 256).toString(16).substr(1);
  var ze,
    Me,
    Ue = function (e, n) {
      return (
        (n = n || 0),
        [
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
          '-',
          De[e[n++]],
          De[e[n++]],
          '-',
          De[e[n++]],
          De[e[n++]],
          '-',
          De[e[n++]],
          De[e[n++]],
          '-',
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
          De[e[n++]],
        ].join('')
      );
    },
    Fe = Ie,
    Ve = 0,
    Re = 0,
    He = Ie,
    Ge = function (e, n, t) {
      if (
        ((t = (n && t) || 0),
        'string' == typeof e &&
          ((n = 'binary' === e ? Array(16) : null), (e = null)),
        ((e = (e = e || {}).random || (e.rng || He)())[6] = (15 & e[6]) | 64),
        (e[8] = (63 & e[8]) | 128),
        n)
      )
        for (var o = 0; 16 > o; ++o) n[t + o] = e[o];
      return n || Ue(e);
    };
  Ge.v1 = function (e, n, t) {
    t = (n && t) || 0;
    var o = n || [],
      r = (e = e || {}).node || ze,
      i = void 0 !== e.clockseq ? e.clockseq : Me;
    if (null == r || null == i) {
      var a = Fe();
      null == r && (r = ze = [1 | a[0], a[1], a[2], a[3], a[4], a[5]]),
        null == i && (i = Me = 16383 & ((a[6] << 8) | a[7]));
    }
    a = void 0 !== e.msecs ? e.msecs : new Date().getTime();
    var c = void 0 !== e.nsecs ? e.nsecs : Re + 1,
      s = a - Ve + (c - Re) / 1e4;
    if (
      (0 > s && void 0 === e.clockseq && (i = (i + 1) & 16383),
      (0 > s || a > Ve) && void 0 === e.nsecs && (c = 0),
      1e4 <= c)
    )
      throw Error("uuid.v1(): Can't create more than 10M uuids/sec");
    for (
      Ve = a,
        Re = c,
        Me = i,
        e = (1e4 * (268435455 & (a += 122192928e5)) + c) % 4294967296,
        o[t++] = (e >>> 24) & 255,
        o[t++] = (e >>> 16) & 255,
        o[t++] = (e >>> 8) & 255,
        o[t++] = 255 & e,
        e = ((a / 4294967296) * 1e4) & 268435455,
        o[t++] = (e >>> 8) & 255,
        o[t++] = 255 & e,
        o[t++] = ((e >>> 24) & 15) | 16,
        o[t++] = (e >>> 16) & 255,
        o[t++] = (i >>> 8) | 128,
        o[t++] = 255 & i,
        i = 0;
      6 > i;
      ++i
    )
      o[t + i] = r[i];
    return n || Ue(o);
  };
  var qe,
    Je,
    Ye = (Ge.v4 = Ge),
    Ke = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  ((Je = qe || (qe = {}))[(Je.none = 0)] = 'none'),
    (Je[(Je.error = 1)] = 'error'),
    (Je[(Je.warn = 2)] = 'warn'),
    (Je[(Je.debug = 3)] = 'debug'),
    (Je[(Je.info = 4)] = 'info');
  var We = (function (e) {
      return (
        void 0 === e && (e = qe.warn),
        {
          setLogLevel: function (n) {
            e = qe[n] ? n : qe.warn;
          },
          warn: function (t, o) {
            for (var r = [], i = 2; i < arguments.length; i++)
              r[i - 2] = arguments[i];
            e >= qe.warn &&
              'undefined' != typeof console &&
              ((i = 'Snowplow: ' + t),
              o
                ? console.warn.apply(console, n([i + '\n', o], r, !1))
                : console.warn.apply(console, n([i], r, !1)));
          },
          error: function (t, o) {
            for (var r = [], i = 2; i < arguments.length; i++)
              r[i - 2] = arguments[i];
            e >= qe.error &&
              'undefined' != typeof console &&
              ((i = 'Snowplow: ' + t + '\n'),
              o
                ? console.error.apply(console, n([i + '\n', o], r, !1))
                : console.error.apply(console, n([i], r, !1)));
          },
          debug: function (t) {
            for (var o = [], r = 1; r < arguments.length; r++)
              o[r - 1] = arguments[r];
            e >= qe.debug &&
              'undefined' != typeof console &&
              console.debug.apply(console, n(['Snowplow: ' + t], o, !1));
          },
          info: function (t) {
            for (var o = [], r = 1; r < arguments.length; r++)
              o[r - 1] = arguments[r];
            e >= qe.info &&
              'undefined' != typeof console &&
              console.info.apply(console, n(['Snowplow: ' + t], o, !1));
          },
        }
      );
    })(),
    Xe = {},
    Qe = {};
  !(function () {
    var e = {
      rotl: function (e, n) {
        return (e << n) | (e >>> (32 - n));
      },
      rotr: function (e, n) {
        return (e << (32 - n)) | (e >>> n);
      },
      endian: function (n) {
        if (n.constructor == Number)
          return (16711935 & e.rotl(n, 8)) | (4278255360 & e.rotl(n, 24));
        for (var t = 0; t < n.length; t++) n[t] = e.endian(n[t]);
        return n;
      },
      randomBytes: function (e) {
        for (var n = []; 0 < e; e--) n.push(Math.floor(256 * Math.random()));
        return n;
      },
      bytesToWords: function (e) {
        for (var n = [], t = 0, o = 0; t < e.length; t++, o += 8)
          n[o >>> 5] |= e[t] << (24 - (o % 32));
        return n;
      },
      wordsToBytes: function (e) {
        for (var n = [], t = 0; t < 32 * e.length; t += 8)
          n.push((e[t >>> 5] >>> (24 - (t % 32))) & 255);
        return n;
      },
      bytesToHex: function (e) {
        for (var n = [], t = 0; t < e.length; t++)
          n.push((e[t] >>> 4).toString(16)), n.push((15 & e[t]).toString(16));
        return n.join('');
      },
      hexToBytes: function (e) {
        for (var n = [], t = 0; t < e.length; t += 2)
          n.push(parseInt(e.substr(t, 2), 16));
        return n;
      },
      bytesToBase64: function (e) {
        for (var n = [], t = 0; t < e.length; t += 3)
          for (
            var o = (e[t] << 16) | (e[t + 1] << 8) | e[t + 2], r = 0;
            4 > r;
            r++
          )
            8 * t + 6 * r <= 8 * e.length
              ? n.push(
                  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.charAt(
                    (o >>> (6 * (3 - r))) & 63
                  )
                )
              : n.push('=');
        return n.join('');
      },
      base64ToBytes: function (e) {
        e = e.replace(/[^A-Z0-9+\/]/gi, '');
        for (var n = [], t = 0, o = 0; t < e.length; o = ++t % 4)
          0 != o &&
            n.push(
              (('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.indexOf(
                e.charAt(t - 1)
              ) &
                (Math.pow(2, -2 * o + 8) - 1)) <<
                (2 * o)) |
                ('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.indexOf(
                  e.charAt(t)
                ) >>>
                  (6 - 2 * o))
            );
        return n;
      },
    };
    Qe = e;
  })();
  var Ze = {
      utf8: {
        stringToBytes: function (e) {
          return Ze.bin.stringToBytes(unescape(encodeURIComponent(e)));
        },
        bytesToString: function (e) {
          return decodeURIComponent(escape(Ze.bin.bytesToString(e)));
        },
      },
      bin: {
        stringToBytes: function (e) {
          for (var n = [], t = 0; t < e.length; t++)
            n.push(255 & e.charCodeAt(t));
          return n;
        },
        bytesToString: function (e) {
          for (var n = [], t = 0; t < e.length; t++)
            n.push(String.fromCharCode(e[t]));
          return n.join('');
        },
      },
    },
    $e = Ze;
  !(function () {
    var e = Qe,
      n = $e.utf8,
      t = $e.bin,
      o = function (o, r) {
        var i = e.wordsToBytes,
          a = o;
        a.constructor == String
          ? (a = n.stringToBytes(a))
          : 'undefined' != typeof Buffer &&
            'function' == typeof Buffer.isBuffer &&
            Buffer.isBuffer(a)
          ? (a = Array.prototype.slice.call(a, 0))
          : Array.isArray(a) || (a = a.toString()),
          (o = e.bytesToWords(a));
        var c = 8 * a.length;
        a = [];
        var s = 1732584193,
          u = -271733879,
          l = -1732584194,
          d = 271733878,
          f = -1009589776;
        for (
          o[c >> 5] |= 128 << (24 - (c % 32)),
            o[15 + (((c + 64) >>> 9) << 4)] = c,
            c = 0;
          c < o.length;
          c += 16
        ) {
          for (var m = s, p = u, g = l, v = d, h = f, y = 0; 80 > y; y++) {
            if (16 > y) a[y] = o[c + y];
            else {
              var w = a[y - 3] ^ a[y - 8] ^ a[y - 14] ^ a[y - 16];
              a[y] = (w << 1) | (w >>> 31);
            }
            (w =
              ((s << 5) | (s >>> 27)) +
              f +
              (a[y] >>> 0) +
              (20 > y
                ? 1518500249 + ((u & l) | (~u & d))
                : 40 > y
                ? 1859775393 + (u ^ l ^ d)
                : 60 > y
                ? ((u & l) | (u & d) | (l & d)) - 1894007588
                : (u ^ l ^ d) - 899497514)),
              (f = d),
              (d = l),
              (l = (u << 30) | (u >>> 2)),
              (u = s),
              (s = w);
          }
          (s += m), (u += p), (l += g), (d += v), (f += h);
        }
        return (
          (i = i.call(e, [s, u, l, d, f])),
          r && r.asBytes
            ? i
            : r && r.asString
            ? t.bytesToString(i)
            : e.bytesToHex(i)
        );
      };
    (o._blocksize = 16), (o._digestsize = 20), (Xe = o);
  })();
  var en,
    nn,
    tn = Xe,
    on = {},
    rn = function () {
      (this.outQueues = []),
        (this.bufferFlushers = []),
        (this.hasLoaded = !1),
        (this.registeredOnLoadHandlers = []);
    },
    an = 'undefined' != typeof window ? re() : void 0,
    cn = Object.freeze({
      __proto__: null,
      addGlobalContexts: function (e, n) {
        ee(n, function (n) {
          n.core.addGlobalContexts(e);
        });
      },
      addPlugin: function (e, n) {
        ee(n, function (n) {
          n.addPlugin(e);
        });
      },
      clearGlobalContexts: function (e) {
        ee(e, function (e) {
          e.core.clearGlobalContexts();
        });
      },
      clearUserData: function (e, n) {
        ee(n, function (n) {
          n.clearUserData(e);
        });
      },
      crossDomainLinker: function (e, n) {
        ee(n, function (n) {
          n.crossDomainLinker(e);
        });
      },
      disableAnonymousTracking: function (e, n) {
        ee(n, function (n) {
          n.disableAnonymousTracking(e);
        });
      },
      discardBrace: function (e, n) {
        ee(n, function (n) {
          n.discardBrace(e);
        });
      },
      discardHashTag: function (e, n) {
        ee(n, function (n) {
          n.discardHashTag(e);
        });
      },
      enableActivityTracking: function (e, n) {
        ee(n, function (n) {
          n.enableActivityTracking(e);
        });
      },
      enableActivityTrackingCallback: function (e, n) {
        ee(n, function (n) {
          n.enableActivityTrackingCallback(e);
        });
      },
      enableAnonymousTracking: function (e, n) {
        ee(n, function (n) {
          n.enableAnonymousTracking(e);
        });
      },
      flushBuffer: function (e, n) {
        ee(n, function (n) {
          n.flushBuffer(e);
        });
      },
      newSession: function (e) {
        ee(e, function (e) {
          e.newSession();
        });
      },
      newTracker: function (e, n, t) {
        if ((void 0 === t && (t = {}), an))
          return te(e, e, 'js-'.concat('3.13.1'), n, an, t);
      },
      preservePageViewId: function (e) {
        ee(e, function (e) {
          e.preservePageViewId();
        });
      },
      removeGlobalContexts: function (e, n) {
        ee(n, function (n) {
          n.core.removeGlobalContexts(e);
        });
      },
      setBufferSize: function (e, n) {
        ee(n, function (n) {
          n.setBufferSize(e);
        });
      },
      setCollectorUrl: function (e, n) {
        ee(n, function (n) {
          n.setCollectorUrl(e);
        });
      },
      setCookiePath: function (e, n) {
        ee(n, function (n) {
          n.setCookiePath(e);
        });
      },
      setCustomUrl: function (e, n) {
        ee(n, function (n) {
          n.setCustomUrl(e);
        });
      },
      setDocumentTitle: function (e, n) {
        ee(n, function (n) {
          n.setDocumentTitle(e);
        });
      },
      setOptOutCookie: function (e, n) {
        ee(n, function (n) {
          n.setOptOutCookie(e);
        });
      },
      setReferrerUrl: function (e, n) {
        ee(n, function (n) {
          n.setReferrerUrl(e);
        });
      },
      setUserId: function (e, n) {
        ee(n, function (n) {
          n.setUserId(e);
        });
      },
      setUserIdFromCookie: function (e, n) {
        ee(n, function (n) {
          n.setUserIdFromCookie(e);
        });
      },
      setUserIdFromLocation: function (e, n) {
        ee(n, function (n) {
          n.setUserIdFromLocation(e);
        });
      },
      setUserIdFromReferrer: function (e, n) {
        ee(n, function (n) {
          n.setUserIdFromReferrer(e);
        });
      },
      setVisitorCookieTimeout: function (e, n) {
        ee(n, function (n) {
          n.setVisitorCookieTimeout(e);
        });
      },
      trackPageView: function (e, n) {
        ee(n, function (n) {
          n.trackPageView(e);
        });
      },
      trackSelfDescribingEvent: function (e, n) {
        ee(n, function (n) {
          n.core.track(P({ event: e.event }), e.context, e.timestamp);
        });
      },
      trackStructEvent: function (e, n) {
        ee(n, function (n) {
          var o = (n = n.core).track,
            r = e.category,
            i = e.action,
            a = e.label,
            c = e.property,
            s = e.value,
            u = t();
          u.add('e', 'se'),
            u.add('se_ca', r),
            u.add('se_ac', i),
            u.add('se_la', a),
            u.add('se_pr', c),
            u.add('se_va', null == s ? void 0 : s.toString()),
            o.call(n, u, e.context, e.timestamp);
        });
      },
      updatePageActivity: function (e) {
        ee(e, function (e) {
          e.updatePageActivity();
        });
      },
      version: '3.13.1',
    }),
    sn = Object.freeze({ __proto__: null, ClientHintsPlugin: ae }),
    un = Object.freeze({ __proto__: null, OptimizelyXPlugin: ce }),
    ln = Object.freeze({ __proto__: null, PerformanceTimingPlugin: se });
  !(function (e) {
    (e.consent = 'consent'),
      (e.contract = 'contract'),
      (e.legalObligation = 'legal_obligation'),
      (e.vitalInterests = 'vital_interests'),
      (e.publicTask = 'public_task'),
      (e.legitimateInterests = 'legitimate_interests');
  })(nn || (nn = {}));
  var dn,
    fn,
    mn,
    pn = {},
    gn = {},
    vn = Object.freeze({
      __proto__: null,
      ConsentPlugin: ue,
      enableGdprContext: function (e, n) {
        void 0 === n && (n = Object.keys(pn));
        var t = e.documentId,
          o = e.documentVersion,
          r = e.documentDescription,
          i = nn[e.basisForProcessing];
        i
          ? n.forEach(function (e) {
              pn[e] &&
                (gn[e] = {
                  basisForProcessing: i,
                  documentId: null != t ? t : null,
                  documentVersion: null != o ? o : null,
                  documentDescription: null != r ? r : null,
                });
            })
          : dn.warn(
              'enableGdprContext: basisForProcessing must be one of: consent, contract, legalObligation, vitalInterests, publicTask, legitimateInterests'
            );
      },
      get gdprBasis() {
        return nn;
      },
      trackConsentGranted: function (e, n) {
        void 0 === n && (n = Object.keys(pn)),
          ne(n, pn, function (n) {
            var t = e.expiry,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
                data: C({
                  id: e.id,
                  version: e.version,
                  name: e.name,
                  description: e.description,
                }),
              };
            (t = P({
              event: {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/consent_granted/jsonschema/1-0-0',
                data: C({ expiry: t }),
              },
            })),
              (o = [o]),
              n.core.track(t, e.context ? e.context.concat(o) : o, e.timestamp);
          });
      },
      trackConsentWithdrawn: function (e, n) {
        void 0 === n && (n = Object.keys(pn)),
          ne(n, pn, function (n) {
            var t = e.all,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/consent_document/jsonschema/1-0-0',
                data: C({
                  id: e.id,
                  version: e.version,
                  name: e.name,
                  description: e.description,
                }),
              };
            (t = P({
              event: {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/consent_withdrawn/jsonschema/1-0-0',
                data: C({ all: t }),
              },
            })),
              (o = [o]),
              n.core.track(t, e.context ? e.context.concat(o) : o, e.timestamp);
          });
      },
    }),
    hn = {},
    yn = !1,
    wn = Object.freeze({
      __proto__: null,
      GeolocationPlugin: le,
      enableGeolocationContext: de,
    }),
    kn = Object.freeze({ __proto__: null, GaCookiesPlugin: fe }),
    bn = {},
    An = {},
    _n = Object.freeze({
      __proto__: null,
      LinkClickTrackingPlugin: me,
      enableLinkClickTracking: function (e, n) {
        void 0 === e && (e = {}),
          void 0 === n && (n = Object.keys(bn)),
          n.forEach(function (n) {
            bn[n] &&
              (bn[n].sharedState.hasLoaded
                ? (ve(e, n), he(n))
                : bn[n].sharedState.registeredOnLoadHandlers.push(function () {
                    ve(e, n), he(n);
                  }));
          });
      },
      refreshLinkClickTracking: function (e) {
        void 0 === e && (e = Object.keys(bn)),
          e.forEach(function (e) {
            bn[e] &&
              (bn[e].sharedState.hasLoaded
                ? he(e)
                : bn[e].sharedState.registeredOnLoadHandlers.push(function () {
                    he(e);
                  }));
          });
      },
      trackLinkClick: function (e, n) {
        void 0 === n && (n = Object.keys(bn)),
          ne(n, bn, function (n) {
            n.core.track(T(e), e.context, e.timestamp);
          });
      },
    });
  !(function (e) {
    (e.CHANGE_FORM = 'change_form'),
      (e.FOCUS_FORM = 'focus_form'),
      (e.SUBMIT_FORM = 'submit_form');
  })(mn || (mn = {}));
  var Pn = [mn.CHANGE_FORM, mn.FOCUS_FORM, mn.SUBMIT_FORM],
    Tn = ['textarea', 'input', 'select'],
    Cn = function (e) {
      return e;
    },
    Sn = {},
    On = Object.freeze({
      __proto__: null,
      FormTrackingPlugin: Ae,
      enableFormTracking: function (e, n) {
        void 0 === e && (e = {}),
          void 0 === n && (n = Object.keys(Sn)),
          n.forEach(function (n) {
            Sn[n] &&
              (Sn[n].sharedState.hasLoaded
                ? ye(Sn[n], e)
                : Sn[n].sharedState.registeredOnLoadHandlers.push(function () {
                    ye(Sn[n], e);
                  }));
          });
      },
    }),
    xn = {},
    En = Object.freeze({
      __proto__: null,
      ErrorTrackingPlugin: _e,
      enableErrorTracking: function (e, n) {
        void 0 === e && (e = {}), void 0 === n && (n = Object.keys(xn));
        var t = e.filter,
          o = e.contextAdder,
          r = e.context;
        B(
          window,
          'error',
          function (e) {
            if ((t && I(t) && t(e)) || null == t) {
              var i = n,
                a = r || [];
              o && I(o) && (a = a.concat(o(e))),
                Pe(
                  {
                    message: e.message,
                    filename: e.filename,
                    lineno: e.lineno,
                    colno: e.colno,
                    error: e.error,
                    context: a,
                  },
                  i
                );
            }
          },
          !0
        );
      },
      trackError: Pe,
    }),
    In = { exports: {} };
  !(function (e) {
    var n, t, o, r, i, a;
    (n = {
      'America/Denver': ['America/Mazatlan'],
      'America/Chicago': ['America/Mexico_City'],
      'America/Asuncion': ['America/Campo_Grande', 'America/Santiago'],
      'America/Montevideo': ['America/Sao_Paulo', 'America/Santiago'],
      'Asia/Beirut':
        'Asia/Amman Asia/Jerusalem Europe/Helsinki Asia/Damascus Africa/Cairo Asia/Gaza Europe/Minsk Africa/Windhoek'.split(
          ' '
        ),
      'Pacific/Auckland': ['Pacific/Fiji'],
      'America/Los_Angeles': ['America/Santa_Isabel'],
      'America/New_York': ['America/Havana'],
      'America/Halifax': ['America/Goose_Bay'],
      'America/Godthab': ['America/Miquelon'],
      'Asia/Dubai': ['Asia/Yerevan'],
      'Asia/Jakarta': ['Asia/Krasnoyarsk'],
      'Asia/Shanghai': ['Asia/Irkutsk', 'Australia/Perth'],
      'Australia/Sydney': ['Australia/Lord_Howe'],
      'Asia/Tokyo': ['Asia/Yakutsk'],
      'Asia/Dhaka': ['Asia/Omsk'],
      'Asia/Baku': ['Asia/Yerevan'],
      'Australia/Brisbane': ['Asia/Vladivostok'],
      'Pacific/Noumea': ['Asia/Vladivostok'],
      'Pacific/Majuro': ['Asia/Kamchatka', 'Pacific/Fiji'],
      'Pacific/Tongatapu': ['Pacific/Apia'],
      'Asia/Baghdad': ['Europe/Minsk', 'Europe/Moscow'],
      'Asia/Karachi': ['Asia/Yekaterinburg'],
      'Africa/Johannesburg': ['Asia/Gaza', 'Africa/Cairo'],
    }),
      (t = function () {
        for (var e = [], n = 0; 11 >= n; n++)
          for (var t = 1; 28 >= t; t++) {
            var o = -new Date(2014, n, t).getTimezoneOffset();
            (o = null !== o ? o : 0),
              e ? e && e[e.length - 1] !== o && e.push(o) : e.push();
          }
        return e;
      }),
      (o = function e(n, t, o) {
        void 0 === t && ((t = 864e5), (o = 36e5));
        var r = new Date(n.getTime() - t).getTime();
        n = n.getTime() + t;
        for (var i = new Date(r).getTimezoneOffset(), a = null; r < n - o; ) {
          var c = new Date(r);
          if (c.getTimezoneOffset() !== i) {
            a = c;
            break;
          }
          r += o;
        }
        return 864e5 === t ? e(a, 36e5, 6e4) : 36e5 === t ? e(a, 6e4, 1e3) : a;
      }),
      (r = function (e, n, t, o) {
        if ('N/A' !== t) return t;
        if ('Asia/Beirut' === n) {
          if (
            ('Africa/Cairo' === o.name &&
              13983768e5 === e[6].s &&
              14116788e5 === e[6].e) ||
            ('Asia/Jerusalem' === o.name &&
              13959648e5 === e[6].s &&
              14118588e5 === e[6].e)
          )
            return 0;
        } else if ('America/Santiago' === n) {
          if (
            ('America/Asuncion' === o.name &&
              14124816e5 === e[6].s &&
              1397358e6 === e[6].e) ||
            ('America/Campo_Grande' === o.name &&
              14136912e5 === e[6].s &&
              13925196e5 === e[6].e)
          )
            return 0;
        } else if ('America/Montevideo' === n) {
          if (
            'America/Sao_Paulo' === o.name &&
            14136876e5 === e[6].s &&
            1392516e6 === e[6].e
          )
            return 0;
        } else if (
          'Pacific/Auckland' === n &&
          'Pacific/Fiji' === o.name &&
          14142456e5 === e[6].s &&
          13961016e5 === e[6].e
        )
          return 0;
        return t;
      }),
      (i = function (e) {
        var t = (function () {
          for (var e = [], n = 0; n < a.olson.dst_rules.years.length; n++) {
            var t = a.olson.dst_rules.years[n],
              r = new Date(t, 0, 1, 0, 0, 1, 0).getTime();
            t = new Date(t, 12, 31, 23, 59, 59).getTime();
            for (
              var i = new Date(r).getTimezoneOffset(), c = null, s = null;
              r < t - 864e5;

            ) {
              var u = new Date(r),
                l = u.getTimezoneOffset();
              l !== i && (l < i && (c = u), l > i && (s = u), (i = l)),
                (r += 864e5);
            }
            (t = !(!c || !s) && { s: o(c).getTime(), e: o(s).getTime() }),
              e.push(t);
          }
          return e;
        })();
        return (function (e) {
          for (var n = 0; n < e.length; n++) if (!1 !== e[n]) return !0;
          return !1;
        })(t)
          ? (function (e, t) {
              for (
                var o = {},
                  i = a.olson.dst_rules.zones,
                  c = i.length,
                  s = n[t],
                  u = 0;
                u < c;
                u++
              ) {
                for (var l = i[u], d = i[u], f = 0, m = 0; m < e.length; m++)
                  if (d.rules[m] && e[m]) {
                    if (!(e[m].s >= d.rules[m].s && e[m].e <= d.rules[m].e)) {
                      f = 'N/A';
                      break;
                    }
                    if (
                      ((f = 0),
                      (f += Math.abs(e[m].s - d.rules[m].s)),
                      864e6 < (f += Math.abs(d.rules[m].e - e[m].e)))
                    ) {
                      f = 'N/A';
                      break;
                    }
                  }
                'N/A' !== (d = r(e, t, f, d)) && (o[l.name] = d);
              }
              for (var p in o)
                if (o.hasOwnProperty(p))
                  for (e = 0; e < s.length; e++) if (s[e] === p) return p;
              return t;
            })(t, e)
          : e;
      }),
      ((a = {
        determine: function (e) {
          var o = !1,
            r = (function () {
              var e = 0,
                n = t();
              return (
                1 < n.length && (e = n[0] - n[1]),
                3 < n.length
                  ? n[0] + ',1,weird'
                  : 0 > e
                  ? n[0] + ',1'
                  : 0 < e
                  ? n[1] + ',1,s'
                  : n[0] + ',0'
              );
            })();
          return (
            (e || void 0 === e) &&
              (o = (function () {
                var e, n;
                if (
                  Intl &&
                  'undefined' != typeof Intl &&
                  void 0 !== Intl.DateTimeFormat &&
                  void 0 !== (e = Intl.DateTimeFormat()) &&
                  void 0 !== e.resolvedOptions
                )
                  return (n = e.resolvedOptions().timeZone) &&
                    (-1 < n.indexOf('/') || 'UTC' === n)
                    ? n
                    : void 0;
              })()),
            o || ((o = a.olson.timezones[r]), void 0 !== n[o] && (o = i(o))),
            {
              name: function () {
                return o;
              },
              using_intl: e || void 0 === e,
              needle: r,
              offsets: t(),
            }
          );
        },
      }).olson = a.olson || {}),
      (a.olson.timezones = {
        '-720,0': 'Etc/GMT+12',
        '-660,0': 'Pacific/Pago_Pago',
        '-660,1,s': 'Pacific/Apia',
        '-600,1': 'America/Adak',
        '-600,0': 'Pacific/Honolulu',
        '-570,0': 'Pacific/Marquesas',
        '-540,0': 'Pacific/Gambier',
        '-540,1': 'America/Anchorage',
        '-480,1': 'America/Los_Angeles',
        '-480,0': 'Pacific/Pitcairn',
        '-420,0': 'America/Phoenix',
        '-420,1': 'America/Denver',
        '-360,0': 'America/Guatemala',
        '-360,1': 'America/Chicago',
        '-360,1,s': 'Pacific/Easter',
        '-300,0': 'America/Bogota',
        '-300,1': 'America/New_York',
        '-270,0': 'America/Caracas',
        '-240,1': 'America/Halifax',
        '-240,0': 'America/Santo_Domingo',
        '-240,1,s': 'America/Asuncion',
        '-210,1': 'America/St_Johns',
        '-180,1': 'America/Godthab',
        '-180,0': 'America/Buenos_Aires',
        '-180,1,s': 'America/Montevideo',
        '-120,0': 'America/Noronha',
        '-120,1': 'America/Noronha',
        '-60,1': 'Atlantic/Azores',
        '-60,0': 'Atlantic/Cape_Verde',
        '0,0': 'UTC',
        '0,1': 'Europe/London',
        '0,1,weird': 'Africa/Casablanca',
        '60,1': 'Europe/Berlin',
        '60,0': 'Africa/Lagos',
        '60,1,weird': 'Africa/Casablanca',
        '120,1': 'Asia/Beirut',
        '120,1,weird': 'Africa/Cairo',
        '120,0': 'Africa/Johannesburg',
        '180,0': 'Asia/Baghdad',
        '180,1': 'Europe/Moscow',
        '210,1': 'Asia/Tehran',
        '240,0': 'Asia/Dubai',
        '240,1': 'Asia/Baku',
        '270,0': 'Asia/Kabul',
        '300,1': 'Asia/Yekaterinburg',
        '300,0': 'Asia/Karachi',
        '330,0': 'Asia/Calcutta',
        '345,0': 'Asia/Katmandu',
        '360,0': 'Asia/Dhaka',
        '360,1': 'Asia/Omsk',
        '390,0': 'Asia/Rangoon',
        '420,1': 'Asia/Krasnoyarsk',
        '420,0': 'Asia/Jakarta',
        '480,0': 'Asia/Shanghai',
        '480,1': 'Asia/Irkutsk',
        '525,0': 'Australia/Eucla',
        '525,1,s': 'Australia/Eucla',
        '540,1': 'Asia/Yakutsk',
        '540,0': 'Asia/Tokyo',
        '570,0': 'Australia/Darwin',
        '570,1,s': 'Australia/Adelaide',
        '600,0': 'Australia/Brisbane',
        '600,1': 'Asia/Vladivostok',
        '600,1,s': 'Australia/Sydney',
        '630,1,s': 'Australia/Lord_Howe',
        '660,1': 'Asia/Kamchatka',
        '660,0': 'Pacific/Noumea',
        '690,0': 'Pacific/Norfolk',
        '720,1,s': 'Pacific/Auckland',
        '720,0': 'Pacific/Majuro',
        '765,1,s': 'Pacific/Chatham',
        '780,0': 'Pacific/Tongatapu',
        '780,1,s': 'Pacific/Apia',
        '840,0': 'Pacific/Kiritimati',
      }),
      (a.olson.dst_rules = {
        years: [2008, 2009, 2010, 2011, 2012, 2013, 2014],
        zones: [
          {
            name: 'Africa/Cairo',
            rules: [
              { e: 12199572e5, s: 12090744e5 },
              { e: 1250802e6, s: 1240524e6 },
              { e: 12858804e5, s: 12840696e5 },
              !1,
              !1,
              !1,
              { e: 14116788e5, s: 1406844e6 },
            ],
          },
          {
            name: 'America/Asuncion',
            rules: [
              { e: 12050316e5, s: 12243888e5 },
              { e: 12364812e5, s: 12558384e5 },
              { e: 12709548e5, s: 12860784e5 },
              { e: 13024044e5, s: 1317528e6 },
              { e: 1333854e6, s: 13495824e5 },
              { e: 1364094e6, s: 1381032e6 },
              { e: 13955436e5, s: 14124816e5 },
            ],
          },
          {
            name: 'America/Campo_Grande',
            rules: [
              { e: 12032172e5, s: 12243888e5 },
              { e: 12346668e5, s: 12558384e5 },
              { e: 12667212e5, s: 1287288e6 },
              { e: 12981708e5, s: 13187376e5 },
              { e: 13302252e5, s: 1350792e6 },
              { e: 136107e7, s: 13822416e5 },
              { e: 13925196e5, s: 14136912e5 },
            ],
          },
          {
            name: 'America/Goose_Bay',
            rules: [
              { e: 122559486e4, s: 120503526e4 },
              { e: 125704446e4, s: 123648486e4 },
              { e: 128909886e4, s: 126853926e4 },
              { e: 13205556e5, s: 129998886e4 },
              { e: 13520052e5, s: 13314456e5 },
              { e: 13834548e5, s: 13628952e5 },
              { e: 14149044e5, s: 13943448e5 },
            ],
          },
          {
            name: 'America/Havana',
            rules: [
              { e: 12249972e5, s: 12056436e5 },
              { e: 12564468e5, s: 12364884e5 },
              { e: 12885012e5, s: 12685428e5 },
              { e: 13211604e5, s: 13005972e5 },
              { e: 13520052e5, s: 13332564e5 },
              { e: 13834548e5, s: 13628916e5 },
              { e: 14149044e5, s: 13943412e5 },
            ],
          },
          {
            name: 'America/Mazatlan',
            rules: [
              { e: 1225008e6, s: 12074724e5 },
              { e: 12564576e5, s: 1238922e6 },
              { e: 1288512e6, s: 12703716e5 },
              { e: 13199616e5, s: 13018212e5 },
              { e: 13514112e5, s: 13332708e5 },
              { e: 13828608e5, s: 13653252e5 },
              { e: 14143104e5, s: 13967748e5 },
            ],
          },
          {
            name: 'America/Mexico_City',
            rules: [
              { e: 12250044e5, s: 12074688e5 },
              { e: 1256454e6, s: 12389184e5 },
              { e: 12885084e5, s: 1270368e6 },
              { e: 1319958e6, s: 13018176e5 },
              { e: 13514076e5, s: 13332672e5 },
              { e: 13828572e5, s: 13653216e5 },
              { e: 14143068e5, s: 13967712e5 },
            ],
          },
          {
            name: 'America/Miquelon',
            rules: [
              { e: 12255984e5, s: 12050388e5 },
              { e: 1257048e6, s: 12364884e5 },
              { e: 12891024e5, s: 12685428e5 },
              { e: 1320552e6, s: 12999924e5 },
              { e: 13520016e5, s: 1331442e6 },
              { e: 13834512e5, s: 13628916e5 },
              { e: 14149008e5, s: 13943412e5 },
            ],
          },
          {
            name: 'America/Santa_Isabel',
            rules: [
              { e: 12250116e5, s: 1207476e6 },
              { e: 12564612e5, s: 12389256e5 },
              { e: 12891204e5, s: 12685608e5 },
              { e: 132057e7, s: 13000104e5 },
              { e: 13520196e5, s: 133146e7 },
              { e: 13834692e5, s: 13629096e5 },
              { e: 14149188e5, s: 13943592e5 },
            ],
          },
          {
            name: 'America/Santiago',
            rules: [
              { e: 1206846e6, s: 1223784e6 },
              { e: 1237086e6, s: 12552336e5 },
              { e: 127035e7, s: 12866832e5 },
              { e: 13048236e5, s: 13138992e5 },
              { e: 13356684e5, s: 13465584e5 },
              { e: 1367118e6, s: 13786128e5 },
              { e: 13985676e5, s: 14100624e5 },
            ],
          },
          {
            name: 'America/Sao_Paulo',
            rules: [
              { e: 12032136e5, s: 12243852e5 },
              { e: 12346632e5, s: 12558348e5 },
              { e: 12667176e5, s: 12872844e5 },
              { e: 12981672e5, s: 1318734e6 },
              { e: 13302216e5, s: 13507884e5 },
              { e: 13610664e5, s: 1382238e6 },
              { e: 1392516e6, s: 14136876e5 },
            ],
          },
          {
            name: 'Asia/Amman',
            rules: [
              { e: 1225404e6, s: 12066552e5 },
              { e: 12568536e5, s: 12381048e5 },
              { e: 12883032e5, s: 12695544e5 },
              { e: 13197528e5, s: 13016088e5 },
              !1,
              !1,
              { e: 14147064e5, s: 13959576e5 },
            ],
          },
          {
            name: 'Asia/Damascus',
            rules: [
              { e: 12254868e5, s: 120726e7 },
              { e: 125685e7, s: 12381048e5 },
              { e: 12882996e5, s: 12701592e5 },
              { e: 13197492e5, s: 13016088e5 },
              { e: 13511988e5, s: 13330584e5 },
              { e: 13826484e5, s: 1364508e6 },
              { e: 14147028e5, s: 13959576e5 },
            ],
          },
          { name: 'Asia/Dubai', rules: [!1, !1, !1, !1, !1, !1, !1] },
          {
            name: 'Asia/Gaza',
            rules: [
              { e: 12199572e5, s: 12066552e5 },
              { e: 12520152e5, s: 12381048e5 },
              { e: 1281474e6, s: 126964086e4 },
              { e: 1312146e6, s: 130160886e4 },
              { e: 13481784e5, s: 13330584e5 },
              { e: 13802292e5, s: 1364508e6 },
              { e: 1414098e6, s: 13959576e5 },
            ],
          },
          {
            name: 'Asia/Irkutsk',
            rules: [
              { e: 12249576e5, s: 12068136e5 },
              { e: 12564072e5, s: 12382632e5 },
              { e: 12884616e5, s: 12697128e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Jerusalem',
            rules: [
              { e: 12231612e5, s: 12066624e5 },
              { e: 1254006e6, s: 1238112e6 },
              { e: 1284246e6, s: 12695616e5 },
              { e: 131751e7, s: 1301616e6 },
              { e: 13483548e5, s: 13330656e5 },
              { e: 13828284e5, s: 13645152e5 },
              { e: 1414278e6, s: 13959648e5 },
            ],
          },
          {
            name: 'Asia/Kamchatka',
            rules: [
              { e: 12249432e5, s: 12067992e5 },
              { e: 12563928e5, s: 12382488e5 },
              { e: 12884508e5, s: 12696984e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Krasnoyarsk',
            rules: [
              { e: 12249612e5, s: 12068172e5 },
              { e: 12564108e5, s: 12382668e5 },
              { e: 12884652e5, s: 12697164e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Omsk',
            rules: [
              { e: 12249648e5, s: 12068208e5 },
              { e: 12564144e5, s: 12382704e5 },
              { e: 12884688e5, s: 126972e7 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Vladivostok',
            rules: [
              { e: 12249504e5, s: 12068064e5 },
              { e: 12564e8, s: 1238256e6 },
              { e: 12884544e5, s: 12697056e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Yakutsk',
            rules: [
              { e: 1224954e6, s: 120681e7 },
              { e: 12564036e5, s: 12382596e5 },
              { e: 1288458e6, s: 12697092e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Yekaterinburg',
            rules: [
              { e: 12249684e5, s: 12068244e5 },
              { e: 1256418e6, s: 1238274e6 },
              { e: 12884724e5, s: 12697236e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Asia/Yerevan',
            rules: [
              { e: 1224972e6, s: 1206828e6 },
              { e: 12564216e5, s: 12382776e5 },
              { e: 1288476e6, s: 12697272e5 },
              { e: 13199256e5, s: 13011768e5 },
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Australia/Lord_Howe',
            rules: [
              { e: 12074076e5, s: 12231342e5 },
              { e: 12388572e5, s: 12545838e5 },
              { e: 12703068e5, s: 12860334e5 },
              { e: 13017564e5, s: 1317483e6 },
              { e: 1333206e6, s: 13495374e5 },
              { e: 13652604e5, s: 1380987e6 },
              { e: 139671e7, s: 14124366e5 },
            ],
          },
          {
            name: 'Australia/Perth',
            rules: [{ e: 12068136e5, s: 12249576e5 }, !1, !1, !1, !1, !1, !1],
          },
          {
            name: 'Europe/Helsinki',
            rules: [
              { e: 12249828e5, s: 12068388e5 },
              { e: 12564324e5, s: 12382884e5 },
              { e: 12884868e5, s: 1269738e6 },
              { e: 13199364e5, s: 13011876e5 },
              { e: 1351386e6, s: 13326372e5 },
              { e: 13828356e5, s: 13646916e5 },
              { e: 14142852e5, s: 13961412e5 },
            ],
          },
          {
            name: 'Europe/Minsk',
            rules: [
              { e: 12249792e5, s: 12068352e5 },
              { e: 12564288e5, s: 12382848e5 },
              { e: 12884832e5, s: 12697344e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Europe/Moscow',
            rules: [
              { e: 12249756e5, s: 12068316e5 },
              { e: 12564252e5, s: 12382812e5 },
              { e: 12884796e5, s: 12697308e5 },
              !1,
              !1,
              !1,
              !1,
            ],
          },
          {
            name: 'Pacific/Apia',
            rules: [
              !1,
              !1,
              !1,
              { e: 13017528e5, s: 13168728e5 },
              { e: 13332024e5, s: 13489272e5 },
              { e: 13652568e5, s: 13803768e5 },
              { e: 13967064e5, s: 14118264e5 },
            ],
          },
          {
            name: 'Pacific/Fiji',
            rules: [
              !1,
              !1,
              { e: 12696984e5, s: 12878424e5 },
              { e: 13271544e5, s: 1319292e6 },
              { e: 1358604e6, s: 13507416e5 },
              { e: 139005e7, s: 1382796e6 },
              { e: 14215032e5, s: 14148504e5 },
            ],
          },
          {
            name: 'Europe/London',
            rules: [
              { e: 12249828e5, s: 12068388e5 },
              { e: 12564324e5, s: 12382884e5 },
              { e: 12884868e5, s: 1269738e6 },
              { e: 13199364e5, s: 13011876e5 },
              { e: 1351386e6, s: 13326372e5 },
              { e: 13828356e5, s: 13646916e5 },
              { e: 14142852e5, s: 13961412e5 },
            ],
          },
          {
            name: 'Africa/Windhoek',
            rules: [
              { e: 12207492e5, s: 120744e7 },
              { e: 12521988e5, s: 12388896e5 },
              { e: 12836484e5, s: 12703392e5 },
              { e: 1315098e6, s: 13017888e5 },
              { e: 13465476e5, s: 13332384e5 },
              { e: 13779972e5, s: 13652928e5 },
              { e: 14100516e5, s: 13967424e5 },
            ],
          },
        ],
      }),
      (e.exports = a);
  })(In);
  var jn = Object.freeze({ __proto__: null, TimezonePlugin: Te }),
    Nn = {},
    Ln = {},
    Dn = Object.freeze({
      __proto__: null,
      EcommercePlugin: Ce,
      addItem: function (e, n) {
        void 0 === n && (n = Object.keys(Nn)),
          n.forEach(function (n) {
            Ln[n] && Ln[n].items.push(e);
          });
      },
      addTrans: function (e, n) {
        void 0 === n && (n = Object.keys(Nn)),
          n.forEach(function (n) {
            Ln[n] && (Ln[n].transaction = e);
          });
      },
      trackAddToCart: function (e, n) {
        void 0 === n && (n = Object.keys(Nn)),
          ne(n, Nn, function (n) {
            var t = (n = n.core).track,
              o = P({
                event: {
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/add_to_cart/jsonschema/1-0-0',
                  data: C({
                    sku: e.sku,
                    quantity: e.quantity,
                    name: e.name,
                    category: e.category,
                    unitPrice: e.unitPrice,
                    currency: e.currency,
                  }),
                },
              });
            t.call(n, o, e.context, e.timestamp);
          });
      },
      trackRemoveFromCart: function (e, n) {
        void 0 === n && (n = Object.keys(Nn)),
          ne(n, Nn, function (n) {
            var t = (n = n.core).track,
              o = P({
                event: {
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/remove_from_cart/jsonschema/1-0-0',
                  data: C({
                    sku: e.sku,
                    quantity: e.quantity,
                    name: e.name,
                    category: e.category,
                    unitPrice: e.unitPrice,
                    currency: e.currency,
                  }),
                },
              });
            t.call(n, o, e.context, e.timestamp);
          });
      },
      trackTrans: function (e) {
        void 0 === e && (e = Object.keys(Nn)),
          ne(e, Nn, function (e) {
            var n = Ln[e.id].transaction;
            if (n) {
              var o = e.core,
                r = o.track,
                i = n.orderId,
                a = n.total,
                c = n.affiliation,
                s = n.tax,
                u = n.shipping,
                l = n.city,
                d = n.state,
                f = n.country,
                m = n.currency,
                p = t();
              p.add('e', 'tr'),
                p.add('tr_id', i),
                p.add('tr_af', c),
                p.add('tr_tt', a),
                p.add('tr_tx', s),
                p.add('tr_sh', u),
                p.add('tr_ci', l),
                p.add('tr_st', d),
                p.add('tr_co', f),
                p.add('tr_cu', m),
                r.call(o, p, n.context, n.timestamp);
            }
            for (n = 0; n < Ln[e.id].items.length; n++)
              (o = Ln[e.id].items[n]),
                (i = (r = e.core).track),
                (a = o.orderId),
                (c = o.sku),
                (s = o.price),
                (u = o.name),
                (l = o.category),
                (d = o.quantity),
                (f = o.currency),
                (m = t()).add('e', 'ti'),
                m.add('ti_id', a),
                m.add('ti_sk', c),
                m.add('ti_nm', u),
                m.add('ti_ca', l),
                m.add('ti_pr', s),
                m.add('ti_qu', d),
                m.add('ti_cu', f),
                i.call(r, m, o.context, o.timestamp);
            Ln[e.id] = { items: [] };
          });
      },
    }),
    Bn = {},
    zn = {},
    Mn = Object.freeze({
      __proto__: null,
      EnhancedEcommercePlugin: Se,
      addEnhancedEcommerceActionContext: function (e, n) {
        void 0 === e && (e = {}), void 0 === n && (n = Object.keys(Bn));
        var t = e.id,
          o = e.affiliation,
          r = e.revenue,
          i = e.tax,
          a = e.shipping,
          c = e.coupon,
          s = e.list,
          u = e.step,
          l = e.option,
          d = e.currency;
        n.forEach(function (e) {
          zn[e] &&
            zn[e].push({
              schema:
                'iglu:com.google.analytics.enhanced-ecommerce/actionFieldObject/jsonschema/1-0-0',
              data: {
                id: t,
                affiliation: o,
                revenue: F(r),
                tax: F(i),
                shipping: F(a),
                coupon: c,
                list: s,
                step: U(u),
                option: l,
                currency: d,
              },
            });
        });
      },
      addEnhancedEcommerceImpressionContext: function (e, n) {
        void 0 === e && (e = {}), void 0 === n && (n = Object.keys(Bn));
        var t = e.id,
          o = e.name,
          r = e.list,
          i = e.brand,
          a = e.category,
          c = e.variant,
          s = e.position,
          u = e.price,
          l = e.currency;
        n.forEach(function (e) {
          zn[e] &&
            zn[e].push({
              schema:
                'iglu:com.google.analytics.enhanced-ecommerce/impressionFieldObject/jsonschema/1-0-0',
              data: {
                id: t,
                name: o,
                list: r,
                brand: i,
                category: a,
                variant: c,
                position: U(s),
                price: F(u),
                currency: l,
              },
            });
        });
      },
      addEnhancedEcommerceProductContext: function (e, n) {
        void 0 === e && (e = {}), void 0 === n && (n = Object.keys(Bn));
        var t = e.id,
          o = e.name,
          r = e.list,
          i = e.brand,
          a = e.category,
          c = e.variant,
          s = e.price,
          u = e.quantity,
          l = e.coupon,
          d = e.position,
          f = e.currency;
        n.forEach(function (e) {
          zn[e] &&
            zn[e].push({
              schema:
                'iglu:com.google.analytics.enhanced-ecommerce/productFieldObject/jsonschema/1-0-0',
              data: {
                id: t,
                name: o,
                list: r,
                brand: i,
                category: a,
                variant: c,
                price: F(s),
                quantity: U(u),
                coupon: l,
                position: U(d),
                currency: f,
              },
            });
        });
      },
      addEnhancedEcommercePromoContext: function (e, n) {
        void 0 === e && (e = {}), void 0 === n && (n = Object.keys(Bn));
        var t = e.id,
          o = e.name,
          r = e.creative,
          i = e.position,
          a = e.currency;
        n.forEach(function (e) {
          zn[e] &&
            zn[e].push({
              schema:
                'iglu:com.google.analytics.enhanced-ecommerce/promoFieldObject/jsonschema/1-0-0',
              data: { id: t, name: o, creative: r, position: i, currency: a },
            });
        });
      },
      trackEnhancedEcommerceAction: function (e, n) {
        void 0 === e && (e = {}),
          void 0 === n && (n = Object.keys(Bn)),
          ne(n, Bn, function (n) {
            var t = zn[n.id].concat(e.context || []);
            (zn[n.id].length = 0),
              n.core.track(
                P({
                  event: {
                    schema:
                      'iglu:com.google.analytics.enhanced-ecommerce/action/jsonschema/1-0-0',
                    data: { action: e.action },
                  },
                }),
                t,
                e.timestamp
              );
          });
      },
    }),
    Un = {},
    Fn = Object.freeze({
      __proto__: null,
      AdTrackingPlugin: Oe,
      trackAdClick: function (e, n) {
        void 0 === n && (n = Object.keys(Un)),
          ne(n, Un, function (n) {
            var t = (n = n.core).track,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/ad_click/jsonschema/1-0-0',
                data: C({
                  targetUrl: e.targetUrl,
                  clickId: e.clickId,
                  costModel: e.costModel,
                  cost: e.cost,
                  bannerId: e.bannerId,
                  zoneId: e.zoneId,
                  impressionId: e.impressionId,
                  advertiserId: e.advertiserId,
                  campaignId: e.campaignId,
                }),
              };
            (o = P({ event: o })), t.call(n, o, e.context, e.timestamp);
          });
      },
      trackAdConversion: function (e, n) {
        void 0 === n && (n = Object.keys(Un)),
          ne(n, Un, function (n) {
            var t = (n = n.core).track,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/ad_conversion/jsonschema/1-0-0',
                data: C({
                  conversionId: e.conversionId,
                  costModel: e.costModel,
                  cost: e.cost,
                  category: e.category,
                  action: e.action,
                  property: e.property,
                  initialValue: e.initialValue,
                  advertiserId: e.advertiserId,
                  campaignId: e.campaignId,
                }),
              };
            (o = P({ event: o })), t.call(n, o, e.context, e.timestamp);
          });
      },
      trackAdImpression: function (e, n) {
        void 0 === n && (n = Object.keys(Un)),
          ne(n, Un, function (n) {
            var t = (n = n.core).track,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/ad_impression/jsonschema/1-0-0',
                data: C({
                  impressionId: e.impressionId,
                  costModel: e.costModel,
                  cost: e.cost,
                  targetUrl: e.targetUrl,
                  bannerId: e.bannerId,
                  zoneId: e.zoneId,
                  advertiserId: e.advertiserId,
                  campaignId: e.campaignId,
                }),
              };
            (o = P({ event: o })), t.call(n, o, e.context, e.timestamp);
          });
      },
    }),
    Vn = {},
    Rn = Object.freeze({
      __proto__: null,
      SiteTrackingPlugin: xe,
      trackSiteSearch: function (e, n) {
        void 0 === n && (n = Object.keys(Vn)),
          ne(n, Vn, function (n) {
            var t = (n = n.core).track,
              o = P({
                event: {
                  schema:
                    'iglu:com.snowplowanalytics.snowplow/site_search/jsonschema/1-0-0',
                  data: C({
                    terms: e.terms,
                    filters: e.filters,
                    totalResults: e.totalResults,
                    pageResults: e.pageResults,
                  }),
                },
              });
            t.call(n, o, e.context, e.timestamp);
          });
      },
      trackSocialInteraction: function (e, n) {
        void 0 === n && (n = Object.keys(Vn)),
          ne(n, Vn, function (n) {
            var t = (n = n.core).track,
              o = {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/social_interaction/jsonschema/1-0-0',
                data: C({
                  action: e.action,
                  network: e.network,
                  target: e.target,
                }),
              };
            (o = P({ event: o })), t.call(n, o, e.context, e.timestamp);
          });
      },
      trackTiming: function (e, n) {
        void 0 === n && (n = Object.keys(Vn));
        var t = e.category,
          o = e.variable,
          r = e.timing,
          i = e.label,
          a = e.context,
          c = e.timestamp;
        ne(n, Vn, function (e) {
          e.core.track(
            P({
              event: {
                schema:
                  'iglu:com.snowplowanalytics.snowplow/timing/jsonschema/1-0-0',
                data: { category: t, variable: o, timing: r, label: i },
              },
            }),
            a,
            c
          );
        });
      },
    }),
    Hn = window.GlobalSnowplowNamespace.shift(),
    Gn = window[Hn];
  Gn.q = (function (n, t) {
    function o(e) {
      var n = e.split(':');
      return [(e = n[0]), (n = 1 < n.length ? n[1].split(';') : void 0)];
    }
    function r(e, n) {
      if (h[e])
        try {
          h[e].apply(null, n);
        } catch (n) {
          We.error(e + ' failed', n);
        }
      else We.warn(e + ' is not an available function');
    }
    function i(e) {
      h = Ee(Ee({}, h), e);
    }
    function a(t) {
      if (
        'string' != typeof t[0] ||
        'string' != typeof t[1] ||
        (void 0 !== t[2] && 'object' != typeof t[2])
      )
        We.error('newTracker failed', Error('Invalid parameters'));
      else {
        var o = ''.concat(n, '_').concat(t[0]),
          r = t[2],
          a = (function (n) {
            var t,
              o =
                null !== (t = null == n ? void 0 : n.contexts) && void 0 !== t
                  ? t
                  : {},
              r = o.performanceTiming;
            (t = o.gaCookies),
              (n = o.geolocation),
              o.optimizelyExperiments,
              o.optimizelyStates,
              o.optimizelyVariations,
              o.optimizelyVisitor,
              o.optimizelyAudiences,
              o.optimizelyDimensions,
              o.optimizelySummary;
            var i = o.optimizelyXSummary;
            o = o.clientHints;
            var a = [];
            return (
              r &&
                ((r = e(ln, ['PerformanceTimingPlugin'])), a.push([se(), r])),
              i && ((r = e(un, ['OptimizelyXPlugin'])), a.push([ce(), r])),
              o &&
                ((r = e(sn, ['ClientHintsPlugin'])),
                a.push([ae('object' == typeof o && o.includeHighEntropy), r])),
              t && ((r = e(kn, ['GaCookiesPlugin'])), a.push([fe(), r])),
              (r = e(vn, ['ConsentPlugin'])),
              a.push([ue(), r]),
              (r = e(wn, ['GeolocationPlugin'])),
              a.push([le(n), r]),
              (r = e(_n, ['LinkClickTrackingPlugin'])),
              a.push([me(), r]),
              (r = e(On, ['FormTrackingPlugin'])),
              a.push([Ae(), r]),
              (r = e(En, ['ErrorTrackingPlugin'])),
              a.push([_e(), r]),
              (r = e(Dn, ['EcommercePlugin'])),
              a.push([Ce(), r]),
              (r = e(Mn, ['EnhancedEcommercePlugin'])),
              a.push([Se(), r]),
              (r = e(Fn, ['AdTrackingPlugin'])),
              a.push([Oe(), r]),
              (r = e(Rn, ['SiteTrackingPlugin'])),
              a.push([xe(), r]),
              (r = e(jn, ['TimezonePlugin'])),
              a.push([Te(), r]),
              a
            );
          })(r);
        (o = te(
          o,
          t[0],
          'js-'.concat(v),
          t[1],
          f,
          Ee(Ee({}, r), {
            plugins: a.map(function (e) {
              return e[0];
            }),
          })
        ))
          ? (m.push(o.id),
            a.forEach(function (e) {
              i(e[1]);
            }))
          : We.warn(t[0] + ' already exists');
      }
    }
    function c(n, t) {
      function o(e) {
        Object.prototype.hasOwnProperty.call(p, e) &&
          (u.clearTimeout(p[e].timeout),
          delete p[e],
          0 === Object.keys(p).length &&
            g.forEach(function (e) {
              var n = e[1];
              void 0 !== h[e[0]] &&
                h[e[0]].length > n.length &&
                Array.isArray(n[0]) &&
                (n = [{}, n[0]]),
                r(e[0], n);
            }));
      }
      var a;
      if (
        'string' == typeof n[0] &&
        d(n[1]) &&
        (void 0 === n[2] || Array.isArray(n[2]))
      ) {
        var c = n[0],
          s = n[1],
          f = n[2];
        (null === (a = n[3]) || void 0 === a || a) &&
          ((a = u.setTimeout(function () {
            o(c);
          }, 5e3)),
          (p[c] = { timeout: a })),
          (a = l.createElement('script')).setAttribute('src', c),
          a.setAttribute('async', '1'),
          B(
            a,
            'error',
            function () {
              o(c),
                We.warn(
                  'Failed to load plugin '.concat(s[0], ' from ').concat(c)
                );
            },
            !0
          ),
          B(
            a,
            'load',
            function () {
              var n = s[1],
                r = u[s[0]];
              if (r && 'object' == typeof r) {
                var a = r[n];
                (n = e(r, ['symbol' == typeof n ? n : n + ''])),
                  h.addPlugin.apply(null, [{ plugin: a.apply(null, f) }, t]),
                  i(n);
              }
              o(c);
            },
            !0
          ),
          l.head.appendChild(a);
      } else {
        if (
          'object' == typeof n[0] &&
          'string' == typeof n[1] &&
          (void 0 === n[2] || Array.isArray(n[2]))
        ) {
          var m = n[0],
            v = n[1];
          if (((a = n[2]), m))
            return (
              (n = m[v]),
              (m = e(m, ['symbol' == typeof v ? v : v + ''])),
              h.addPlugin.apply(null, [{ plugin: n.apply(null, a) }, t]),
              void i(m)
            );
        }
        We.warn('Failed to add Plugin: '.concat(n[1]));
      }
    }
    function s() {
      for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
      for (t = 0; t < e.length; t += 1) {
        var i = e[t],
          s = Array.prototype.shift.call(i);
        if (I(s))
          try {
            for (var u = {}, l = 0, d = oe(m, on); l < d.length; l++) {
              var f = d[l];
              u[f.id.replace(''.concat(n, '_'), '')] = f;
            }
            s.apply(u, i);
          } catch (e) {
            We.error('Tracker callback failed', e);
          } finally {
            continue;
          }
        (s = (u = o(s))[0]),
          (u = u[1]),
          'newTracker' === s
            ? a(i)
            : ((u = u
                ? u.map(function (e) {
                    return ''.concat(n, '_').concat(e);
                  })
                : m),
              'addPlugin' === s
                ? c(i, u)
                : ((l = void 0),
                  (l =
                    0 < i.length
                      ? [i[0], u]
                      : void 0 !== h[s] && 2 === h[s].length
                      ? [{}, u]
                      : [u]),
                  0 < Object.keys(p).length ? g.push([s, l]) : r(s, l)));
      }
    }
    for (
      var u = window,
        l = document,
        f = re(),
        m = [],
        p = {},
        g = [],
        v = '3.13.1',
        h = e(cn, ['version']),
        y = 0;
      y < t.length;
      y++
    )
      s(t[y]);
    return { push: s };
  })(Hn, Gn.q);
})();
//# sourceMappingURL=/assets/snowplow/sp.js-28d8e23ee884abcae50751dc7772c39d653bf35064e03160b35bfa0c5c5a35e6.map
//!
;
